import React, { useState, useEffect, useRef } from 'react';
import classes from './ReconciliationNav.module.css';
import logo from '../../../Assets/rotating-logo.png';
import icon from '../../../Assets/Component 1 (4).png';
import iconinactive from '../../../Assets/dshbrd-inactive.png';
import trsanstin from '../../../Assets/cardtrsnct.png';
import RotatingLogo from '../../../Assets/rotating-logo.png'
import trsanstinactive from '../../../Assets/Component 1 (3).png';
import acctn from '../../../Assets/Accountingicon.png';
import acctnactive from '../../../Assets/Component 1 (2).png';
import rprts from '../../../Assets/reportsicon.png';
import rprtsactive from '../../../Assets/Component 1 (6).png';
import bnkn from '../../../Assets/bankin-icon.png';
import bnknactive from '../../../Assets/Component 1 (7).png';
import { IoCloseCircleOutline } from "react-icons/io5";
import Upload1 from '../../../Assets/upload-new1.svg';
import stngs from '../../../Assets/settings-icon.png';
import stngsactive from '../../../Assets/Component 1 (8).png';
import CurrencyInput from 'react-currency-input-field';
import { Dropdown, Col, Row, Button, Modal, Form, Spinner, Badge } from 'react-bootstrap';
import Select from 'react-select';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaBars, FaTimes } from "react-icons/fa"; 
import { CiMenuFries } from "react-icons/ci";
import { FaRegTimesCircle } from "react-icons/fa";
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom";


import axios from 'axios';
import Swal from 'sweetalert2';

// import CreateAccountModalPage from '../../CreateAccount/CreateAccountModal';
import { BASE_URL } from '../../../Components/Styles/API/API';



const permissionToMenuMap = {
  'Manage Configurations': 
  { menu: 'Configurations', 
    paths: [
      '/reconciliation/reconciliation_keyword',
      '/reconciliation/create_account',
      '/reconciliation/set_predefine_format',
  ]},
  'Ledger/Cashbook': { menu: 'Ledger/Cashbook', paths: [
    '/reconciliation/upload_record_in_excel',
    '/reconciliation/upload_predefined_format',
  ]},
  'Bank Statement': { menu: 'Bank Statement', paths: [
    '/reconciliation/upload_bank_excel',
    '/reconciliation/upload_bank_pdf',
    '/reconciliation/upload_bank_predefined_format',
  ]},
  'Transaction Matching': {menu: 'Transaction Matching', paths: [

   '/reconciliation/match_record_auto',
   '/reconciliation/manual_matching',
  ]},
  'Reports': {menu: 'Reports', paths: [
   '/reconciliation/match_items_report',
   '/reconciliation/outstanding_items_report',
   '/reconciliation/outstanding_items_ledger',
   '/reconciliation/outstanding_items_statement',
   
  ]},
  
};

export default function HeaderNav() {
  const location = useLocation();
  const [statementBalance, setStatementBalance] = useState('');
  const [cashBalance, setCashBalance] = useState('');
   const [teller, setTeller] = useState("")
   const [balanceProcess, setBalanceProcess] = useState([]);
  const [ user, setUser ] = useState('');
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [selectedAccountId, setSelectedAccountId] = useState(null);
  const [selectedAccount2, setSelectedAccount2] = useState('');
  const [selectedDate2, setSelectedDate2] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedCashDate, setSelectedCashDate] = useState('');
  const [selectedStatementDate, setSelectedStatementDate] = useState('');
  const userDropdownRef = useRef(null);
    const [show6, setShow6] = useState(false);
const [showRemittanceExcelModal, setShowRemittanceExcelModal] = useState(false);
  const [showRemittanceModal, setShowRemittanceModal] = useState(false);
const [excelFile, setExcelFile] = useState(null);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const navigate = useNavigate();
  const [monthLoading, setMonthLoading] = useState(false);
  const [show, setShow] = useState(false);
    const [subCat2, setSubcat2] = useState([]);
  const [provinceID, setProvinceID] = useState('');
  const [show1, setShow1] = useState(false);
   const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [show2648, setShow2648] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [createLoading, setCreateLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [company, setCompany] = useState('');
  const [userType, setUserType] = useState('');
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState('');
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [interest, setInterest] = useState(0.00);
      const [totalRepayment, setTotalRepayment] = useState(0.00);
      const [monthlyDeduction, setMonthlyDeduction] = useState('');
      const [duration, setDuration] = useState('');
  const [province, setProvince] = useState('');
  const [validity, setValidity] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [permits, setPermits] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [admin, setAdmin] = useState('');
  const [description, setDescription] = useState("");
  const [outstanding, setOutstanding] = useState("");
  const [currMonth, setCurrMonth] = useState('');
  const [loading, setLoading] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const [minDate, setMinDate] = useState("");
    const [maxDate, setMaxDate] = useState("");
    const [bankID, setBankID] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);
   const [selectOptions, setSelectOptions] = useState([]);
       const [loans, setLoans] = useState([]);
       const [showAutomaticMatchingModal, setShowAutomaticMatchingModal] = useState(false);
       const [showCreateAccountModal, setShowCreateAccountModal] = useState(false);
const [matchingOptions, setMatchingOptions] = useState({
  exactMatch: false,
  manyToManyMatches: false,
  similarDetailsMatches: false,
  similarDetailsMatchesReversal: false,
  dirtyMatches: false,
});
const [showImportTransactionsModal, setShowImportTransactionsModal] = useState(false);
  const toggleNav = () => setNavOpen(!navOpen);
  const handleCustomerChange = (selectedOption) => {
        setSelectedCustomer(selectedOption.value);
        setOutstanding(selectedOption.balance);
      };
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const value9 = await localStorage.getItem('userEmail');
      const value2 = await localStorage.getItem('allPermissions');
      const value3 = await localStorage.getItem('admin');
      const value7 = await localStorage.getItem('companyName');
      const value8 = await localStorage.getItem('validity');
      const curr = await localStorage.getItem('currentMonth');
      const permitsss = await localStorage.getItem('modules');
      const balanceProcess = await localStorage.getItem('balanceProcess');
      const bankId = await localStorage.getItem('bankID');
      const provinceId = await localStorage.getItem('provinceID');
      const cashBookBal = await localStorage.getItem('cashbookAccountOpening');
      const statementBal = await localStorage.getItem('statementAccountOpening');
      const cashDate = await localStorage.getItem('cashbookDate');
      const statementDate = await localStorage.getItem('statementDate');

      if (value !== null && value.trim() !== '') {
        setBearer(value);
      } else {
        navigate('/login');
        return;
      }
        if (provinceId !== null) {
        setProvinceID(provinceId);
      }
        if (cashBookBal !== null) {
        setCashBalance(cashBookBal);
        
      }
        if (statementBal !== null) {
        setStatementBalance(statementBal);
        console.log(statementBal, "new");
      }
      if (value2 !== null) {
          // const parsedPermitions = JSON.parse(value2);
          // const permitionNames = parsedPermitions.map((permit) => permit.name);
          setPermissions(value2);
          console.log(value2);
        }
      if (permitsss !== null) {
        const parsedPermits = JSON.parse(permitsss);
        const permitNames = parsedPermits.map((permit) => permit.name);
        setPermits(permitNames);
        console.log('Parsed Permissions:', parsedPermits);
      }
      if (value1 !== null) {
        setUser(value1);
      }
      if (bankId !== null) {
        setBankID(bankId);
      }
      if (balanceProcess !== null) {
        setBalanceProcess(JSON.parse(balanceProcess));
      }
      if (value9 !== null) {
        setUserEmail(value9);
      }
      if (value8 !== null) {
        setValidity(value8);
      }
      if (value3 !== null) {
        setAdmin(value3);
      }
      if (value7 !== null) {
        setCompany(value7);
      }
      if (cashDate !== null) {
        setSelectedCashDate(cashDate);
      }
      if (statementDate !== null) {
        setSelectedStatementDate(statementDate);
      }
      if (curr !== null) {
        console.log(curr);
        const date = new Date(curr);
      
        setCurrMonth(date);
      
        const startOfDateRange = new Date(1900, 0, 1);
     
        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      
        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0'); 
          const day = String(date.getDate()).padStart(2, '0');     
          return `${year}-${month}-${day}`;
        };
      
        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));
      
        console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }


  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${bearer}`,
  };
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
    const handlePaymentModeChange = (event) => {
        setSelectedPaymentMode(event.target.value);
    };
const [paymentMethod, setPaymentMethod] = useState([]);

const handleMatchingOptionChange = (option) => {
  setMatchingOptions(prev => ({
    ...prev,
    [option]: !prev[option]
  }));
};

   const uploadStatement4 = async (file) => {
    try {    
      const formData = new FormData();
      formData.append('file', file);
      formData.append('bank_id', bankID);
      // formData.append('date', selectedDate2);
      const response = await axios.post(
        // `${BASE_URL}/reconciliation/upload_cash_statement`,
        `${BASE_URL}/reconciliation/continual_bank_statement_setup`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      setBalances2(response.data.data);
      // handleClose();
      // handleShow2(true);
      // Reset form fields
      // setSelectedImage("");
      // Swal.fire({
      //   icon: 'success',
      //   title: 'Successful',
      //   text: response.data.message,
      // });
      //
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
    
    }
  };

const handleStartMatching = () => {
  // Handle the matching logic here
  console.log('Starting matching with options:', matchingOptions);
  
  // You can add your matching logic here
  // For now, just close the modal and show a success message
  setShowAutomaticMatchingModal(false);
  Swal.fire({
    icon: 'success',
    title: 'Matching Started',
    text: 'Automatic matching process has been initiated.',
  });
  
  // Reset checkboxes
  setMatchingOptions({
    exactMatch: false,
    manyToManyMatches: false,
    similarDetailsMatches: false,
    similarDetailsMatchesReversal: false,
    dirtyMatches: false,
  });
};

console.log(balanceProcess, "new")
      const fetchPaymentMethod = async () => {
            setLoading(true);
    
    
            try {
                const response = await axios.get(`${BASE_URL}/income/get-payment-method`,
                    {
    
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${bearer}`
                        }
                    }
                );
                const resultss = response.data?.data;
                setPaymentMethod(resultss);
    
                  console.log(resultss, "PaymentModes");
            } catch (error) {
                const errorStatus = error.response.data.message;
                console.error(errorStatus);
            } finally {
                setLoading(false);
            }
        };

        const [incomeAmount, setIncomeAmount] = useState();
          const handleValueChanges = (value) => {
        setIncomeAmount(value);
    };

    const handleOpenCreateAccount = () => {
  setShowCreateAccountModal(true);
  setOpenDropdown(null);
};

  const navItems = [
    { label: 'Dashboard', path: '/reconciliation', icon: iconinactive, activeIcon: icon },
    { label: 'Configurations', path: '/reconciliation/reconciliation_keyword', icon: stngs, activeIcon: stngsactive },
    { label: 'Cashbook', path: '/reconciliation/upload_record_in_excel', icon: trsanstin, activeIcon: trsanstinactive },
    { label: 'Bank Statement', path: '/reconciliation/upload_bank_excel', icon: acctn, activeIcon: acctnactive },
    { label: 'Transaction Matching', path: '/reconciliation/match_record_auto', icon: bnkn, activeIcon: bnknactive },
    { label: 'Reports', path: '/reconciliation_report', icon: rprts, activeIcon: rprtsactive },
    // { label: 'Accounting', path: '/accounting/view_journal_entries', icon: acctn, activeIcon: acctnactive },
    // { label: 'Reports', path: '/accounting/report', icon: rprts, activeIcon: rprtsactive },
  ];

  

  const dropdownMenus = {
    Configurations: [
      { label: 'Reconciliation Keyword', path: '/reconciliation/reconciliation_keyword',  },
      { label: 'Create New Account', isCreateAccountModal: true,  },
      { label: 'Set Predefined Format', path: '/reconciliation/set_predefine_format',  },
    ],
    Cashbook: [
      { label: 'Import Transactions - Excel',  isImportTransactionsModal: true  },
      // { label: 'Upload using Pre-Defined Format', path: '/reconciliation/upload_predefined_format',  },
     
    ],
     'Bank Statement': [ // ← Changed from "Bank" to "Bank Statement"
    { label: 'Upload Transactions - Excel', isUploadRemittanceExcel: true },
  ],
  'Transaction Matching': [ // ← Changed from "Transaction" to "Transaction Matching"
    { label: 'Automatic Matching', isAutomaticMatchingModal: true },
    { label: 'Manual Matching', 
      // isCreateAccountModal: true 
      // path: '/accounting/bank_reconciliationnew'
      onClick: () => {
      const width = 1200;
      const height = 800;
      const left = (window.screen.width / 2) - (width / 2);
      const top = (window.screen.height / 2) - (height / 2);

      window.open(
        '/accounting/bank_reconciliationnew',
        '_blank',
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
      );
    },
    },
  ],
 

// Reports: [
//   { label: "Match Items Report", path: '/reconciliation/match_items_report', },
//   { label: "Outstanding Items Report", path: '/reconciliation/outstanding_items_report', },
//   { label: "Outstanding Items in Ledger-Excel", path: '/reconciliation/outstanding_items_ledger',  },
//   { label: "Outstanding Items in Statement-Excel", path: '/reconciliation/outstanding_items_statement', },
// ],
  
  };
 const handleImageChange2 = (event) => {
    const file = event.target.files[0];
  };
  // Filter navItems based on permissions
 // Show all navItems without permission filtering
const filteredNavItems = navItems;

  const handleClose6 = () => {
    // navigate(-1);
    setShow6(false)};

  useEffect(() => {
    const handleClickOutside = (e) => {
      const dropdownContainer = document.querySelector(`.${classes.dropdown}`);
      if (dropdownContainer && !dropdownContainer.contains(e.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

   const handleLogout = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}/logout`,
        {},
        { headers }
      );
      navigate('/login');
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const changePassword122 = async () => {
    setCreateLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}/change_password`,
        {
          current_password: currentPassword,
          new_password: password,
          password_confirmation: passwordConfirmation,
        },
        { headers }
      );
      setCurrentPassword('');
      setPassword('');
      setPasswordConfirmation('');
      setShow(false);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
    } finally {
      setCreateLoading(false);
    }
  };

  const getNextMonthName = (currMonth) => {
      // Parse the currMonth string to create a Date object
      const date = new Date(currMonth);
  
      // Extract the current month (0-based index, so adding 1 to get the next month)
      let nextMonth = date.getMonth() + 1; // getMonth() is 0-based (Jan = 0)
  
      // If the next month is December (11) and we need to roll over to January
      if (nextMonth > 11) {
        nextMonth = 0;
      }
  
      // Create a new date object for the next month (day set to 1 for simplicity)
      const nextMonthDate = new Date(date.getFullYear(), nextMonth, 1);
  
      // Use toLocaleString() to get the month name in words
      const nextMonthName = nextMonthDate.toLocaleString("default", {
        month: "long",
      });
  
      return nextMonthName;
    };
  
    const getPrevMonthName = (currMonth) => {
      // Parse the currMonth string to create a Date object
      const date = new Date(currMonth);
  
      // Extract the current month and subtract 1 to get the previous month
      let prevMonth = date.getMonth() - 1; // getMonth() is 0-based (Jan = 0)
  
      // If the previous month is before January, roll over to December of the previous year
      if (prevMonth < 0) {
        prevMonth = 11; // December
        date.setFullYear(date.getFullYear() - 1); // Move to the previous year
      }
  
      // Create a new date object for the previous month (day set to 1 for simplicity)
      const prevMonthDate = new Date(date.getFullYear(), prevMonth, 1);
  
      // Use toLocaleString() to get the month name in words
      const prevMonthName = prevMonthDate.toLocaleString("default", {
        month: "long",
      });
  
      return prevMonthName;
    };
  
    const getCurrentMonthName = (currMonth) => {
      // Parse the currMonth string to create a Date object
      const date = new Date(currMonth);
  
      // Use toLocaleString() to get the current month name in words
      const currentMonthName = date.toLocaleString("default", { month: "long" });
  
      return currentMonthName;
    };

      
            useEffect(() => {
              if (bearer) {
                  fetchPaymentMethod();
           
              }
          }, [bearer]);

      const [isLoading, setIsLoading] = useState(false);
       const [loanInterest, setLoanInterest] = useState(0.00);
       const [cus, setCus] = useState([]);

          const fetchSupplierss = async () => {
            setIsLoading(true);
            try {
              const response = await axios.get(`${BASE_URL}/customer/loan-customers`, { headers });
              console.log(response)
              // const response = await axios.get(`${BASE_URL}/customer/no-pagination`, { headers });
              const results = response.data?.data?.data;
              console.log("results:", results)
              const options = results.map((item) => ({
                label: item.name,
                value: item.id,
              }));
              setCustomers(results);
              setSelectOptions(options);
            } catch (error) {
              const errorStatus = error.response?.data?.message;
              console.log(errorStatus);
              setCustomers([]);
            } finally {
              setIsLoading(false);
            }
          };

          const fetchCustomers = async () => {
            setIsLoading(true);
            try {
              const response = await axios.get(`${BASE_URL}/customer/no-pagination`, { headers });
              console.log(response)
              // const response = await axios.get(`${BASE_URL}/customer/no-pagination`, { headers });
              const results = response.data?.data;
              console.log("results:", results)
              const options = results.map((item) => ({
                label: item.name,
                value: item.id,
                balance: item.balance
              }));
              setCus(options);
            } catch (error) {
              const errorStatus = error.response?.data?.message;
              console.log(errorStatus);
              setCus([]);
            } finally {
              setIsLoading(false);
            }
          };
    
           const fetchLoans = async () => {
              setIsLoading(true);
              try {
                const response = await axios.get(`${BASE_URL}/account/fetch-loans`, { headers });
                const results = response.data?.data;
          
                const options1 = results.map((item) => ({
                  label: item.description,
                  value: item.id,
                  interest: item.interest
                }));
                setLoans(options1);
                // setSelectOptions(options);
              } catch (error) {
                const errorStatus = error.response?.data?.message;
                console.log(errorStatus);
                setLoans([]);
              } finally {
                setIsLoading(false);
              }
            };
    
             useEffect(() => {
            if (bearer) {
              fetchSupplierss();
              fetchLoans();
              fetchCustomers();
            }
          }, [bearer]);
    
          const [selectedLoan, setSelectedLoan] = useState(null);
          
    
    
           const handleLoanTypeChange = (selectedOption) => {
        setSelectedLoan(selectedOption.value);
        const selectedLoanInterest = selectedOption.interest;
        setLoanInterest(selectedLoanInterest === null ? "0.00" : selectedLoanInterest);
      };

  const handleTrashClick1 = async () => {
      const currentMonthName = getCurrentMonthName(currMonth);
      const nextMonthName = getNextMonthName(currMonth);
      const confirmed = await Swal.fire({
        title: "Are you sure?",
        text: `You are about to change your working month from ${currentMonthName} to ${nextMonthName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Change it!",
        cancelButtonText: "No, Cancel",
      });
  
      if (!confirmed.isConfirmed) {
        return; // User canceled, do nothing
      }
  
      // Show a Swal saying "Changing the working month, please wait..." and prevent interaction
      Swal.fire({
        title: "Changing the working month...",
        text: "Please wait while we process your request.",
        icon: "info",
        allowOutsideClick: false,
        showConfirmButton: false, // Hide the confirm button
        didOpen: () => {
          Swal.showLoading(); // Show loading spinner
        },
      });
  
      setMonthLoading(true);
  
      try {
        const response = await axios.post(
          `${BASE_URL}/provinces/update-province-month`,
          {}, // Empty body
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${bearer}`,
            },
          }
        );
  
        // Close the loading Swal and show the success message
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.message,
        });
        navigate("/login");
      } catch (error) {
        let errorMessage = "An error occurred. Please try again.";
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (typeof error.response.data.message === "string") {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join("; ");
          } else if (typeof error.response.data.message === "object") {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
  
        // Close the loading Swal and show the error message
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: errorMessage,
        });
        console.log(error);
      } finally {
        setMonthLoading(false); // Stop loading
      }
    };
  
    const handleTrashClick2 = async () => {
      const currentMonthName = getCurrentMonthName(currMonth);
      const prevMonthName = getPrevMonthName(currMonth);
      const confirmed = await Swal.fire({
        title: "Are you sure?",
        text: `You are about to reset your working month from ${currentMonthName} to ${prevMonthName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Reset it!",
        cancelButtonText: "No, Cancel",
      });
  
      if (!confirmed.isConfirmed) {
        return; // User canceled, do nothing
      }
  
      // Show a Swal saying "Changing the working month, please wait..." and prevent interaction
      Swal.fire({
        title: "Resetting the working month...",
        text: "Please wait while we process your request.",
        icon: "info",
        allowOutsideClick: false,
        showConfirmButton: false, // Hide the confirm button
        didOpen: () => {
          Swal.showLoading(); // Show loading spinner
        },
      });
  
      setMonthLoading(true);
  
      try {
        const response = await axios.post(
          `${BASE_URL}/provinces/reverse-province-month`,
          {}, // Empty body
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${bearer}`,
            },
          }
        );
  
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.message,
        });
        navigate("/login");
        //   setTrashClicked1(true);
      } catch (error) {
        let errorMessage = "An error occurred. Please try again.";
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (typeof error.response.data.message === "string") {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join("; ");
          } else if (typeof error.response.data.message === "object") {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: errorMessage,
        });
        console.log(error);
      } finally {
        setMonthLoading(false); // Stop loading
      }
    };

  const getInitials = (name) => {
    const parts = name?.trim().split(' ');
    const firstTwo = parts?.slice(0, 2);
    return firstTwo.map((part) => part.charAt(0).toUpperCase()).join('');
  };

  const initials = getInitials(user);

    const [showLoanModal, setShowLoanModal] = useState(false);
       const handleClose = () => {
    setShowLoanModal(false);
  };

  const [showCustomer, setShowCustomer] = useState(false);
        const handleCloseCustomer = () => setShowCustomer(false);
        const handleShowCustomer = () => {
           setShowCustomer(true);
           handleClose();
        }
        const [selectedImage, setSelectedImage] = useState('');
  
    const createLoans = async () => {
      setLoading(true);
  
      try {
  
        const formData = new FormData();
        formData.append('doc', selectedImage);
        // formData.append("bank", selectedBank);
        formData.append("loan_name", selectedLoan);
  
  
        const response = await axios.post(
          `${BASE_URL}/account/upload-staff-loan-payment`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': `Bearer ${bearer}`
            }
          }
        );
  
        console.log(response, "heeee");
        // setBalances(response.data.data);
        handleCloseCustomer();
        // Reset form fields
        setSelectedImage("");
        Swal.fire({
          icon: 'success',
          title: 'Successful',
          text: response.data.message,
        }).then(() => {
          window.location.reload();
        });
        // toast.success(response.data.message);
      } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: JSON.stringify(error.response.data.message),
          });
        }
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
  
     const handleImageChange = (event) => {
      const file = event.target.files[0];
      setSelectedImage(file);
    };

    const [selectedDatess, setSelectedDatess] = useState('');
      const handleDateChangess = (event) => {
        setSelectedDatess(event.target.value);
      };
    
        const handleSupplierChange = (selectedOption) => {
        setSelectedCustomer(selectedOption.value);
      }

       const [principalAmount, setPrincipalAmount] = useState(''); 
        
          const handleValueChange = (value, name, values) => {
          setPrincipalAmount(value);
        };
      
        const handleValueChange1 = (value, name, values) => {
          setLoanInterest(value);
        };
      
        const handleValueChange2 = (value, name, values) => {
          setInterest(value);
        };

        const [banks, setBanks] = useState([]);
         const [selectedBanks, setSelectedBanks] = useState(null)

          const handleBankChange = (selectedOption) => {
             setSelectedBanks(selectedOption);
           }
         const fetchBanks = async () => {
             setIsLoading(true);
             try {
               const response = await axios.get(`${BASE_URL}/account/bank-accounts`, { headers });
               const results = response.data?.data;
         
               const options1 = results.map((item) => ({
                 label: item.gl_name,
                 value: item.id,
               }));
               setBanks(options1);
               // setSelectOptions(options);
             } catch (error) {
               const errorStatus = error.response?.data?.message;
               console.log(errorStatus);
               setBanks([]);
             } finally {
               setIsLoading(false);
             }
           };

           useEffect(() => {
                   if (bearer) {
                   
                     fetchBanks();
                   
                   }
                 }, [bearer]);
              const handlePaymentChange = (selectedOption) => {
             if (selectedOption) {
                 const selectedValue = selectedOption.value; // Access the value here
                 console.log('Selected value:', selectedValue); // For debugging
                 // Set the selected payment mode or perform any other action you need
                 // setSelectedPaymentMode(selectedValue); // Assuming you're updating the payment mode
           
                 setSelectedBanks(selectedValue);
           
             } else {
                 console.error('Selected option is undefined');
             }
           };
         
      
        const handleValueChange3 = (value, name, values) => {
          setTotalRepayment(value);
        };
      
        const handleValueChange4 = (value, name, values) => {
          setMonthlyDeduction(value);
        };
      
        
          useEffect(() => {
            const calculateInterestRate = () => {
              const calculatedInterestRate = (parseFloat(loanInterest) / 100) * parseFloat(principalAmount);
              const formattedInterestRate = isNaN(calculatedInterestRate) ? "0.00" : calculatedInterestRate.toFixed(2);
        
              setInterest(formattedInterestRate);
            };
        
            calculateInterestRate();
          }, [loanInterest, principalAmount]);
        
        
          useEffect(() => {
            const calculateTotalRepayment = () => {
              const calculatedTotalRepayment = parseFloat(principalAmount) + parseFloat(interest);
              const formattedTotalRepayment = isNaN(calculatedTotalRepayment) ? "0.00" : calculatedTotalRepayment.toFixed(2);
        
              setTotalRepayment(formattedTotalRepayment);
            };
        
            calculateTotalRepayment();
          }, [interest, principalAmount]);
        
          useEffect(() => {
            const calculateReturn = () => {
              const calculatedReturn = parseFloat(totalRepayment) / parseFloat(duration);
              const formattedReturn = isNaN(calculatedReturn) ? "0.00" : calculatedReturn.toFixed(2);
        
              setMonthlyDeduction(formattedReturn);
            };
        
            calculateReturn();
          }, [totalRepayment, duration]);


            
          
                const createLoan = async () => {
                  setCreateLoading(true);
                  try {
                    const response = await axios.post(
                      `${BASE_URL}/account/staff-loan`,
                      {
                        member_name: selectedCustomer || '',
                        loan_name: selectedLoan || '',
                        bank: selectedBanks.value,
                        principal_amount: principalAmount,
                        interest_amount: interest,
                        total_repayment: totalRepayment,
                        monthly_deduction: monthlyDeduction,
                        loan_interest: loanInterest,
                        duration: duration,
                        transaction_date: selectedDatess,
                        // cheque_number: cheque
              
              
                      },
                      { headers }
                    );
                    console.log(response.data.message)
                    Swal.fire({
                      icon: 'success',
                      title: 'Success',
                      text: response.data.message,
                    });
              handleClose();
             
                    setSelectedCustomer(null);
                    setSelectedLoan(null);
                    setSelectedBanks(null);
                    // setSelectedDate('');
                    setSelectedDatess('');
                    setPrincipalAmount('');
                    setLoanInterest('');
                    setInterest('');
                    setTotalRepayment('');
                    // setCheque('');
                    setDuration('');
                    setMonthlyDeduction('');
              
                    // navigate('/loans_advances')
              
                    // return
                    //   Swal.fire({
                    //     icon: 'success',
                    //     title: 'Success',
                    //     text: response.data.message,
                    //   });
                    //   console.log(response.data);
              
                    // } catch (error) {
                    //   const errorStatus = error.response.data.message;
                    //   Swal.fire({
                    //     icon: 'error',
                    //     title: 'Failed',
                    //     text: errorStatus,
                    //   });
                    //   console.log(error);
              
                  } catch (error) {
                    let errorMessage = 'An error occurred. Please try again.';
                    if (error.response && error.response.data && error.response.data.message) {
                      if (typeof error.response.data.message === 'string') {
                        errorMessage = error.response.data.message;
                      } else if (Array.isArray(error.response.data.message)) {
                        errorMessage = error.response.data.message.join('; ');
                      } else if (typeof error.response.data.message === 'object') {
                        console.log(error.response.data.message);
                      }
                    }
                    Swal.fire({
                      icon: 'error',
                      title: 'Failed',
                      text: JSON.stringify(error.response.data.data),
                    });
                  } finally {
                    setCreateLoading(false);
                  }
                };

                // Upload Payables modals
const [showTypeModal, setShowTypeModal] = useState(false);
const [showFormModal, setShowFormModal] = useState(false);
const [payableType, setPayableType] = useState(""); // "Salary" or "Pension"
const handleOpenUploadType = () => setShowTypeModal(true);
const handleCloseTypeModal = () => setShowTypeModal(false);

const handleSelectType = (type) => {
  setPayableType(type);
  setShowTypeModal(false);
  setShowFormModal(true);
};

const handleCloseFormModal = () => {
  setShowFormModal(false);
  setPayableType("");
};


  const [debit1, setDebit1] = useState([]);
  const [debit2, setDebit2] = useState([]);
  const [debit3, setDebit3] = useState([]);
  const [debit4, setDebit4] = useState([]);

    const fetchDebit1 = async () => {
      setLoading(true);
  
      try {
        const response = await axios.get(`${BASE_URL}/account/expenses`, { headers });
  
        const debt1 = response.data?.data;
        const oopt1 = debt1.map((item) => ({
          label: `${item.gl_code} - ${item.gl_name}`,
          value: item.id,
  
  
        }));
        setDebit1(oopt1);
  
  
  
      } catch (error) {
        const errorStatus = error.response.data.message;
        // console.error(errorStatus);
      } finally {
        setLoading(false);
      }
    };
    const fetchDebit3 = async () => {
      setLoading(true);
  
      try {
        const response = await axios.get(`${BASE_URL}/account/bank-accounts`, { headers });
  
        const debt1 = response.data?.data;
        const oopt1 = debt1.map((item) => ({
          label: `${item.gl_code} - ${item.gl_name}`,
          value: item.id,
  
  
        }));
        setDebit3(oopt1);
  
  
  
      } catch (error) {
        const errorStatus = error.response.data.message;
        // console.error(errorStatus);
      } finally {
        setLoading(false);
      }
    };
  
    const fetchDebit2 = async () => {
      setLoading(true);
  
      try {
        const response = await axios.get(`${BASE_URL}/account/payables`, { headers });
  
        const debt2 = response.data?.data;
        const oopt2 = debt2.map((item) => ({
          label: `${item.gl_code} - ${item.gl_name}`,
          value: item.id,
  
  
        }));
        setDebit2(oopt2);
  
  
  
      } catch (error) {
        const errorStatus = error.response.data.message;
        // console.error(errorStatus);
      } finally {
        setLoading(false);
      }
    };
    const fetchDebit4 = async () => {
      setLoading(true);
  
      try {
        const response = await axios.get(`${BASE_URL}/account/cash`, { headers });
  
        const debt2 = response.data?.data;
        const oopt2 = debt2.map((item) => ({
          label: `${item.gl_code} - ${item.gl_name}`,
          value: item.id,
  
  
        }));
        setDebit4(oopt2);
  
  
  
      } catch (error) {
        const errorStatus = error.response.data.message;
        // console.error(errorStatus);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      if (bearer) {
        fetchDebit1();
        fetchDebit2();
        fetchDebit3();
        fetchDebit4();
      }
    }, [bearer]);

    const[selectedExpenses, setSelectedExpenses] = useState('')
    const[date, setDate] = useState('')
    const [selectedImagesss, setSelectedImagesss] = useState('');
      const[selectedPayable, setSelectedPayable] = useState('')
    
       const handleImageChangessss = (event) => {
    const file = event.target.files[0];
    setSelectedImagesss(file);
  };
      const handledExpenses = (selectedOption) => {
        setSelectedExpenses(selectedOption.value);
      };
      const handlePayables = (selectedOption) => {
        setSelectedPayable(selectedOption.value);
      };
             const [tableData, setTableData] = useState([]);
             const [selectedBeneficiary, setSelectedBeneficiary] = useState('');  
             
               const fetchCharts = async () => {
                 setIsLoading(true);
                 try {
                   const response = await axios.get(`${BASE_URL}/beneficiary`, { headers });
                   const results = response.data?.data;
             
                   const opt1 = results.map((item) => ({
                     label: item.name,
                     value: item.id,
                   }));
                   console.log(response);
                   setTableData(opt1);
             
                 } catch (error) {
                   const errorStatus = error.response?.data?.message;
                   console.log(errorStatus);
                   setTableData([]);
                 } finally {
                   setIsLoading(false);
                 }
               };
             
               useEffect(() => {
                 if (bearer) {
                   fetchCharts();
             
                 }
               }, [bearer]);

                 const uploadStatement = async () => {
                   setCreateLoading(true);
               
                   try {
               
                     const formData = new FormData();
                     formData.append('file', selectedImagesss);
                     formData.append('payable', selectedPayable);
                     formData.append('expense', selectedExpenses);
                     formData.append('transaction_date', date);
               
               
                     const response = await axios.post(
                       `${BASE_URL}/upload-payable-excel`,
                       formData,
                       {
                         headers: {
                           'Content-Type': 'multipart/form-data',
                           'Authorization': `Bearer ${bearer}`
                         }
                       }
                     );
               
                     console.log(response, "heeee");
                     // setBalances(response.data.data);
                     // handleClose();
                     // Reset form fields
                     setSelectedImagesss("");
                     Swal.fire({
                       icon: 'success',
                       title: 'Successful',
                       text: response.data.message,
                     });
                     // toast.success(response.data.message);
                   } catch (error) {
                     let errorMessage = 'An error occurred. Please try again.';
                     if (error.response && error.response.data && error.response.data.message) {
                       if (typeof error.response.data.message === 'string') {
                         errorMessage = error.response.data.message;
                       } else if (Array.isArray(error.response.data.message)) {
                         errorMessage = error.response.data.message.join('; ');
                       } else if (typeof error.response.data.message === 'object') {
                         errorMessage = JSON.stringify(error.response.data.message);
                       }
                       Swal.fire({
                         icon: 'error',
                         title: 'Failed',
                         text: JSON.stringify(error.response.data.message),
                       });
                     }
                     console.error(error);
                   } finally {
                     setCreateLoading(false);
                   }
                 };

                 const uploadRemittance = async () => {
                   setCreateLoading(true);
               
                   try {
               
                     const formData = new FormData();
                     formData.append('file', excelFile);
                     formData.append('bank', selectedBanks);
                     formData.append('customer_id', selectedCustomer);
                     formData.append('transaction_date', date);
                    //  formData.append('mode', selectedPaymentMode);
                     formData.append('cheque_number', teller);
               
               
                     const response = await axios.post(
                       `${BASE_URL}/upload_remittance_payment_new`,
                       formData,
                       {
                         headers: {
                           'Content-Type': 'multipart/form-data',
                           'Authorization': `Bearer ${bearer}`
                         }
                       }
                     );
               
                     console.log(response, "heeee");
                     // setBalances(response.data.data);
                     // handleClose();
                     // Reset form fields
                     setSelectedImagesss("");
                     Swal.fire({
                       icon: 'success',
                       title: 'Successful',
                       text: response.data.message,
                     });
                     // toast.success(response.data.message);
                   } catch (error) {
                     let errorMessage = 'An error occurred. Please try again.';
                     if (error.response && error.response.data && error.response.data.message) {
                       if (typeof error.response.data.message === 'string') {
                         errorMessage = error.response.data.message;
                       } else if (Array.isArray(error.response.data.message)) {
                         errorMessage = error.response.data.message.join('; ');
                       } else if (typeof error.response.data.message === 'object') {
                         errorMessage = JSON.stringify(error.response.data.message);
                       }
                       Swal.fire({
                         icon: 'error',
                         title: 'Failed',
                         text: JSON.stringify(error.response.data.message),
                       });
                     }
                     console.error(error);
                   } finally {
                     setCreateLoading(false);
                   }
                 };

                 const [create, setCreate] = useState(false);

                 const createRemitance = async () => {
                   setCreate(true);
               
                   try {
               
                     const formData = new FormData();
                     formData.append('bank', selectedBanks);
                     formData.append('customer_id', selectedCustomer);
                     formData.append('transaction_date', date);
                     formData.append('mode', selectedPaymentMode);
                     formData.append('cheque_number', teller);
                     formData.append('description', description);
                     formData.append('amount', incomeAmount);
               
               
                     const response = await axios.post(
                       `${BASE_URL}/save-casual-payment`,
                       formData,
                       {
                         headers: {
                           'Content-Type': 'multipart/form-data',
                           'Authorization': `Bearer ${bearer}`
                         }
                       }
                     );
               
                     console.log(response, "heeee");
                     // setBalances(response.data.data);
                     // handleClose();
                     // Reset form fields
                    //  setSelectedImagesss("");
                     Swal.fire({
                       icon: 'success',
                       title: 'Successful',
                       text: response.data.message,
                     });
                     // toast.success(response.data.message);
                   } catch (error) {
                     let errorMessage = 'An error occurred. Please try again.';
                     if (error.response && error.response.data && error.response.data.message) {
                       if (typeof error.response.data.message === 'string') {
                         errorMessage = error.response.data.message;
                       } else if (Array.isArray(error.response.data.message)) {
                         errorMessage = error.response.data.message.join('; ');
                       } else if (typeof error.response.data.message === 'object') {
                         errorMessage = JSON.stringify(error.response.data.message);
                       }
                       Swal.fire({
                         icon: 'error',
                         title: 'Failed',
                         text: JSON.stringify(error.response.data.message),
                       });
                     }
                     console.error(error);
                   } finally {
                     setCreate(false);
                   }
                 };
                 const uploadStatements = async () => {
                   setCreateLoading(true);
               
                   try {
               
                     const formData = new FormData();
                     formData.append('file', selectedImagesss);
                     formData.append('payable', selectedPayable);
                     formData.append('expense', selectedExpenses);
                     formData.append('transaction_date', date);
                     formData.append('beneficiary_id', selectedBeneficiary.value);
               
               
                     const response = await axios.post(
                       `${BASE_URL}/upload-beneficiary-payable-excel`,
                       formData,
                       {
                         headers: {
                           'Content-Type': 'multipart/form-data',
                           'Authorization': `Bearer ${bearer}`
                         }
                       }
                     );
               
                     console.log(response, "heeee");
                     // setBalances(response.data.data);
                     // handleClose();
                     // Reset form fields
                     setSelectedImagesss("");
                     Swal.fire({
                       icon: 'success',
                       title: 'Successful',
                       text: response.data.message,
                     });
                     // toast.success(response.data.message);
                   } catch (error) {
                     let errorMessage = 'An error occurred. Please try again.';
                     if (error.response && error.response.data && error.response.data.message) {
                       if (typeof error.response.data.message === 'string') {
                         errorMessage = error.response.data.message;
                       } else if (Array.isArray(error.response.data.message)) {
                         errorMessage = error.response.data.message.join('; ');
                       } else if (typeof error.response.data.message === 'object') {
                         errorMessage = JSON.stringify(error.response.data.message);
                       }
                       Swal.fire({
                         icon: 'error',
                         title: 'Failed',
                         text: JSON.stringify(error.response.data.message),
                       });
                     }
                     console.error(error);
                   } finally {
                     setCreateLoading(false);
                   }
                 };
   const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };
  const [show2, setShow2] = useState(false);

  
  const handleShow6 = () => {
    setShow2(false);
    setShow6(true);
  };
  const [balances, setBalances] = useState([]);
      const [balances2, setBalances2] = useState([]);
  const [balance, setBalance] = useState('');
const handleClose2Process = () => setShow2Process(false);
  const [show2Process, setShow2Process] = useState(false);
   const [show5, setShow5] = useState(false);
   const [show6Process, setShow6Process] = useState(false);
  const [createLoading2, setCreateLoading2] = useState(false);
  
 const [subCatProcess, setSubcatProcess] = useState([]);
 const [fixedDate, setFixedDate] = useState('');
   const [fixedDate2, setFixedDate2] = useState('');
   const [currentPage2, setCurrentPage2] = useState(1);
     const [rowsPerPage, setRowsPerPage] = useState(100);
        const [totalDebitCount, setTotalDebitCount] = useState('');
     const [totalCreditCount, setTotalCreditCount] = useState('');
     const [totalDebitCount2, setTotalDebitCount2] = useState('');
     const [totalCreditCount2, setTotalCreditCount2] = useState('');
     const [totalAmountDebit, setTotalAmountDebit] = useState('');
     const [totalAmountCredit, setTotalAmountCredit] = useState('');
     const [totalAmountDebit2, setTotalAmountDebit2] = useState('');
     const [totalAmountCredit2, setTotalAmountCredit2] = useState('');
     const [closingBalance, setClosingBalance] = useState('');
     const [closingBalance2, setClosingBalance2] = useState('');
     const [balanceLoading, setBalanceLoading] = useState(false);
     
   const handleShow2Process = () => {
    setShow6Process(false);
    setShow5(false);
    setShow2Process(true);
    };
   const [selectedAccountProcess, setSelectedAccountProcess] = useState('');

    const fetchSubCatProcess = async () => {
        setLoading(true);
    
        try {
          const response = await axios.get(
            `${BASE_URL}/reconciliation/set-accounts`,
            {
    
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${bearer}`
              }
            }
          );
          const results = response.data?.data;
          setSubcatProcess(results);
  
    
          //   console.log(results, "NIYIN");
        } catch (error) {
          const errorStatus = error?.response?.data?.message;
          console.error(errorStatus);
        } finally {
          setLoading(false);
        }
      };

      useEffect(() => {
          if (bearer) {
            // fetchData();
            // fetchSubCat();
            // fetchSubCat2();
            fetchSubCatProcess();
          }
        }, [bearer]);

      const optProcess = subCatProcess.map((item) => ({
          label: item.gl_name,
          value: item.id,
          fixeddate: item.setup?.cashbook_last_date,
          fixeddateState: item.setup?.smt_last_date,
        }));

          const handleAccountChangeProcess = (selectedOption) => {
    setSelectedAccountProcess(selectedOption.value);
    setFixedDate2(selectedOption.fixeddate);
    setFixedDate(selectedOption.fixeddateState);
    setSelectedDate(selectedOption.fixeddate);  
  };

   const pullCashbook = async () => {
      setCreateLoading2(true);    
      try {    
        const formData = new FormData();
        formData.append('bank_id', selectedAccountProcess);
        const response = await axios.post(
          // `${BASE_URL}/reconciliation/upload_cash_statement`,
          `${BASE_URL}/reconciliation/get-all-month-cashbook`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': `Bearer ${bearer}`
            }
          }
        );
  
        console.log(response, "heeee");
        // setBalanceProcess(response.data.data);
        // handleClose();
        handleShow2Process(true);
        // Reset form fields
        // setSelectedImage("");
        // Swal.fire({
        //   icon: 'success',
        //   title: 'Successful',
        //   text: response.data.message,
        // });
        // toast.success(response.data.message);
      } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: JSON.stringify(error.response.data.message),
          });
        }
        console.error(error);
      } finally {
    //         setTimeout(() => {
    //   setCreateLoading2(false);
    // }, 4000);
        setCreateLoading2(false);
      }
    };
  const postBalances2 = async () => {
    setBalanceLoading(true);
    try {
      //  return;
      const response = await axios.post(
        // `${BASE_URL}/payment_voucher/save-bank-statement`,
        `${BASE_URL}/reconciliation/set-up-account-for-reconciliation`,
        {
          total_debit: totalAmountDebit,
          total_credit: totalAmountCredit,
          // cashbook_uuid: dataSource[0]?.uuid,        
          statement_uuid: balances2[0]?.uuid,        
          cashbook_date: selectedDate,        
          statement_date: selectedDate2,        
          statement_balance: statementBalance,        
          cashbook_balance: cashBalance,        
          account_id: bankID,        
        },
        { headers }
      );
      console.log(response.data?.message, "heeee");
      
      // handleClose6();
      // setBalances([]);
      // setBalances2([]);
      // setTotalAmountCredit('');
      // setTotalAmountCredit2('');
      // setTotalAmountDebit2('');
      // setSelectedDate('');
      // setSelectedDate2('');
      // setStatementBalance('');
      // setCashBalance('');
      // setSelectedAccount('');
      // fetchSubCat2();
      // fetchSubCat();
      
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      //
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
        console.log(error);
      }
    } finally {
      setBalanceLoading(false);
    }
  };
  const postBalances1 = async () => {
    setBalanceLoading(true);
    try {
      //  return;
      const response = await axios.post(
        // `${BASE_URL}/payment_voucher/save-bank-statement`,
        `${BASE_URL}/reconciliation/save-month-cashbook-for-reconciliation`,
        {
          // total_debit: totalAmountDebit,
          // total_credit: totalAmountCredit,
          // cashbook_uuid: dataSource[0]?.uuid,        
          // statement_uuid: balances2[0]?.uuid,        
          cashbook_date: selectedCashDate,        
          // statement_date: selectedDate2,        
          // statement_balance: statementBalance,        
          // cashbook_balance: cashBalance,        
          bank_id: bankID,        
        },
        { headers }
      );
      console.log(response.data?.message, "heeee");
      setShowImportTransactionsModal(false);
      // handleClose6();
      // setBalances([]);
      // setBalances2([]);
      // setTotalAmountCredit('');
      // setTotalAmountCredit2('');
      // setTotalAmountDebit2('');
      // setSelectedDate('');
      // setSelectedDate2('');
      // setStatementBalance('');
      // setCashBalance('');
      // setSelectedAccount('');
      // fetchSubCat2();
      // fetchSubCat();
      
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      //
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
        console.log(error);
      }
    } finally {
      setBalanceLoading(false);
    }
  };
    const indexOfLastRow = currentPage2 * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const dataSource = balanceProcess;
  // const dataSource = balances && balances.length > 0 ? balances : balanceProcess;
  const currentRows = dataSource.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages2 = Math.ceil(dataSource.length / rowsPerPage);

      const calculateTotalDebit = () => {
       const total = dataSource.reduce((acc, item) => {
        return item.debit ? acc + parseFloat(item.debit || 0) : acc;
      }, 0);

  const formattedTotal1 = total.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  
      setTotalAmountDebit(formattedTotal1);
    };
  
      const calculateTotalDebit2 = () => {
      const total = balances2.reduce((acc, item) => {
        return item.debit ? acc + parseFloat(item.debit || 0) : acc;
      }, 0);
  
      const formattedTotal1 = total.toLocaleString('en-US', {
        minimumIntegerDigits: 1,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
  
      console.log(formattedTotal1, "debitTotal2");
  
  
      setTotalAmountDebit2(formattedTotal1);
    };
  
    const calculateTotalCredit = () => {
  
    const total1 = dataSource.reduce((acc, item) => {
        return item.credit ? acc + parseFloat(item.credit || 0) : acc;
      }, 0);

  const formattedTotal = total1.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  setTotalAmountCredit(formattedTotal);
};

    console.log(dataSource, "nwew");
  
    const calculateTotalCredit2 = () => {
      const total1 = balances2.reduce((acc, item) => {
        return item.credit ? acc + parseFloat(item.credit || 0) : acc;
      }, 0);
  
      const formattedTotal11 = total1.toLocaleString('en-US', {
        minimumIntegerDigits: 1,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
          console.log(formattedTotal11, "creditTotal2");
  
      setTotalAmountCredit2(formattedTotal11);
    };
  
      const calculateClosingBalance = () => {
          const credit = parseFloat(totalAmountCredit.replace(/,/g, '')) || 0;
          const debit = parseFloat(totalAmountDebit.replace(/,/g, '')) || 0;
          const statement = parseFloat(cashBalance) || 0;
          const closing = statement + debit - credit;
          const formattedTotal1 = closing.toLocaleString('en-US', {
        minimumIntegerDigits: 1,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
  
      setClosingBalance(formattedTotal1);
    };

      const handleAccountChange2 = (selectedOption) => {
    setSelectedAccount2(selectedOption.value);
    setSelectedAccountId(selectedOption?.value);
    setFixedDate(selectedOption.fixeddate);
    setSelectedDate("");  
  };

   const fetchSubCat2 = async () => {
        setLoading(true);
    
        try {
          const response = await axios.get(
            `${BASE_URL}/reconciliation/set-accounts`,
            {
    
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${bearer}`
              }
            }
          );
          const results = response.data?.data;
          setSubcat2(results);
  
    
          //   console.log(results, "NIYIN");
        } catch (error) {
          const errorStatus = error?.response?.data?.message;
          console.error(errorStatus);
        } finally {
          setLoading(false);
        }
      };

   const opt2 = subCat2.map((item) => ({
          label: item.gl_name,
          value: item.id,
          fixeddate: item.setup?.smt_last_date,
        }));
  
    const calculateClosingBalance2 = () => {
          const credit = parseFloat(totalAmountCredit2.replace(/,/g, '')) || 0;
          const debit = parseFloat(totalAmountDebit2.replace(/,/g, '')) || 0;
          const statement = parseFloat(statementBalance) || 0;
          const closing = statement + credit - debit;
          const formattedTotal1 = closing.toLocaleString('en-US', {
        minimumIntegerDigits: 1,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
  
      console.log(formattedTotal1, "closingbalanccce");
  
      setClosingBalance2(formattedTotal1);
    };
  
   const calculateDebitCount = () => {
 const count = dataSource.filter(item => parseFloat(item.debit) > 0).length;
  setTotalDebitCount(count);
};
  
  const calculateCreditCount = () => {
  const count = dataSource.filter(item => parseFloat(item.credit) > 0).length;
  setTotalCreditCount(count);
};
  
    const calculateDebitCount2 = () => {
    const count = balances2.filter(item => parseFloat(item.debit) > 0).length;
    console.log(count, "debitcount2");
    setTotalDebitCount2(count);
  };
  
  const calculateCreditCount2 = () => {
    const count = balances2.filter(item => parseFloat(item.credit) > 0).length;
      console.log(count, "creditcount2");
    setTotalCreditCount2(count);
  };
  
     useEffect(() => {
        calculateTotalDebit();
        calculateTotalCredit();
        calculateDebitCount();
        calculateCreditCount();
        // calculateClosingBalance();
      }, [dataSource]);
  
     useEffect(() => {
        calculateTotalDebit2();
        calculateTotalCredit2();
        calculateDebitCount2();
        calculateCreditCount2();
        // calculateClosingBalance2();
    
      }, [balances2]);
  
      useEffect(() => {
        if (totalAmountCredit && totalAmountDebit && cashBalance !== null) {
          calculateClosingBalance();
        }
      }, [totalAmountCredit, totalAmountDebit, cashBalance]);
  
      useEffect(() => {
        if (totalAmountCredit2 && totalAmountDebit2 && statementBalance !== null) {
          calculateClosingBalance2();
        }
      }, [totalAmountCredit2, totalAmountDebit2, statementBalance]);
useEffect(() => {
    if (bearer) {
  
      fetchSubCat2();
      // fetchSubCatProcess();
    }
  }, [bearer]);

   const handleReconcilePage2 = () => {
        if (!selectedAccountId || !selectedDate) {
          Swal.fire({
            title: 'Missing field',
            text: 'Please select both account and date.',
            icon: 'warning',
            confirmButtonText: 'OK'
          });
          return;
        }
  
        localStorage.setItem("selected_account_id", selectedAccountId);
        localStorage.setItem("selected_date", selectedDate);
  
        const width = 1200;
        const height = 800;
  
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);
  
        window.open(
          '/accounting/bank_reconciliationnew',
          '_blank',
          `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
        );
  
      };

  return (
    <div className={classes.entnav22}>
      <NavLink to="/reconciliation">  <img src={logo} alt="Logo" className={classes.logo} /></NavLink>

      <div className={`${classes.headerNav} ${classes.desktopOnly}`}>
 {filteredNavItems.map((item) => {
  const isActive = location.pathname.startsWith(item.path);
  const hasDropdown = dropdownMenus[item.label];
  const filteredDropdownItems = hasDropdown ? dropdownMenus[item.label] : [];

  return hasDropdown && filteredDropdownItems.length > 0 ? (
    <div
      key={item.label}
      className={`${classes.dshbrdnav} ${isActive ? classes.activeNav : ''}`}
    >
      <div
        className={classes.dshbrdnavMain}
        onClick={() =>
          setOpenDropdown(openDropdown === item.label ? null : item.label)
        }
      >
        <img
          src={isActive ? item.activeIcon : item.icon}
          alt={`${item.label} icon`}
          className={classes.dshbrdicon}
        />
        <p
          className={isActive ? classes.activeText : ''}
          style={{ whiteSpace: 'nowrap' }}
        >
          {item.label}
        </p>
      </div>
      {openDropdown === item.label && (
        <div className={classes.dropdown}>
          {filteredDropdownItems.map((sub, index) =>
            sub.children ? (
              <div key={index} className={classes.dropdownWithSub}>
                <span className={classes.dropdownItem}>{sub.label}</span>
                <div className={classes.subDropdown}>
                  {sub.children.map((child, cIndex) => {
                    if (child.isUploadRemittanceExcel) {
                      return (
                        <div
                          key={cIndex}
                          className={classes.dropdownItem}
                          onClick={() => {
                            setShowRemittanceExcelModal(true);
                            setOpenDropdown(null);
                          }}
                        >
                          {child.label}
                        </div>
                      );
                    }
                    if (child.isRemittanceModal) {
                      return (
                        <div
                          key={cIndex}
                          className={classes.dropdownItem}
                          onClick={() => {
                            setShowRemittanceModal(true);
                            setOpenDropdown(null);
                          }}
                        >
                          {child.label}
                        </div>
                      );
                    }
                    if (child.isCreateAccountModal) {
                      return (
                        <div
                          key={cIndex}
                          className={classes.dropdownItem}
                          onClick={() => {
                            setShowCreateAccountModal(true);
                            setOpenDropdown(null);
                          }}
                        >
                          {child.label}
                        </div>
                      );
                    }
                    if (child.isImportTransactionsModal) {
                      return (
                        <div
                          key={cIndex}
                          className={classes.dropdownItem}
                          onClick={() => {
                            setShowImportTransactionsModal(true);
                            setOpenDropdown(null);
                          }}
                        >
                          {child.label}
                        </div>
                      );
                    }
                    // Add onClick handler for Manual Matching
                    if (child.onClick) {
                      return (
                        <div
                          key={cIndex}
                          className={classes.dropdownItem}
                          onClick={() => {
                            child.onClick();
                            setOpenDropdown(null);
                          }}
                        >
                          {child.label}
                        </div>
                      );
                    }
                    return (
                      <NavLink
                        key={cIndex}
                        to={child.path}
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ""}`
                        }
                      >
                        {child.label}
                      </NavLink>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div key={index}>
                {sub.isAutomaticMatchingModal ? (
                  <div
                    className={classes.dropdownItem}
                    onClick={() => {
                      setShowAutomaticMatchingModal(true);
                      setOpenDropdown(null);
                    }}
                  >
                    {sub.label}
                  </div>
                ) : sub.isUploadPayableModal ? (
                  <div
                    className={classes.dropdownItem}
                    onClick={() => {
                      handleOpenUploadType();
                      setOpenDropdown(null);
                    }}
                  >
                    {sub.label}
                  </div>
                ) : sub.isUploadRemittanceExcel ? (
                  <div
                    className={classes.dropdownItem}
                    onClick={() => {
                      setShowRemittanceExcelModal(true);
                      setOpenDropdown(null);
                    }}
                  >
                    {sub.label}
                  </div>
                ) : sub.isRemittanceModal ? (
                  <div
                    className={classes.dropdownItem}
                    onClick={() => {
                      setShowRemittanceModal(true);
                      setOpenDropdown(null);
                    }}
                  >
                    {sub.label}
                  </div>
                ) : sub.isModal ? (
                  <div
                    className={classes.dropdownItem}
                    onClick={() => {
                      setShowLoanModal(true);
                      setOpenDropdown(null);
                    }}
                  >
                    {sub.label}
                  </div>
                ) : sub.isCreateAccountModal ? (
                  <div
                    className={classes.dropdownItem}
                    onClick={() => {
                      setShowCreateAccountModal(true);
                      setOpenDropdown(null);
                    }}
                  >
                    {sub.label}
                  </div>
                ) : sub.isImportTransactionsModal ? (
                  <div
                    className={classes.dropdownItem}
                    onClick={() => {
                      setShowImportTransactionsModal(true);
                      setOpenDropdown(null);
                    }}
                  >
                    {sub.label}
                  </div>
                ) : 
                // Add this condition for Manual Matching with onClick
                sub.onClick ? (
                  <div
                    className={classes.dropdownItem}
                    onClick={() => {
                      sub.onClick();
                      setOpenDropdown(null);
                    }}
                  >
                    {sub.label}
                  </div>
                ) : (
                  <NavLink
                    to={sub.path}
                    onClick={() => setOpenDropdown(null)}
                    className={({ isActive }) =>
                      `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ""}`
                    }
                  >
                    {sub.label}
                  </NavLink>
                )}
              </div>
            )
          )}
        </div>
      )}
    </div>
  ) : (
    <Link to={item.path} key={item.label} className={classes.link}>
      <div
        className={`${classes.dshbrdnav} ${isActive ? classes.activeNav : ''}`}
      >
        <img
          src={isActive ? item.activeIcon : item.icon}
          alt={`${item.label} icon`}
          className={classes.dshbrdicon}
        />
        <p className={isActive ? classes.activeText : ''}>{item.label}</p>
      </div>
    </Link>
  );
})}
      </div>

       <Modal show={showRemittanceExcelModal} onHide={() => setShowRemittanceExcelModal(false)} size="lg" keyboard={true} centered dialogClassName={classes.customModalWidth}>
                    {/* <Modal.Header closeButton> */}
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: 16,
                    }}>
                      <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                     
                    }}>
                    <Modal.Title style={{fontSize: 16, fontWeight: 700}}>Upload Statement of Account</Modal.Title>
                     <p style={{fontSize: 14}}>Upload your outstanding bank statement.</p>
                    </div>
                    <IoCloseCircleOutline onClick={() => setShowRemittanceExcelModal(false)} style={{color: 'blue', fontSize: 30, cursor: 'pointer'}}/>
                    </div>
                    {/* </Modal.Header> */}
                    <Modal.Body>
                      <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Row>
                          <Col md={4}>
                            <Form.Group className="mb-3">
                               <div style={{
                                    background: '#f5f7fb',
          borderRadius: 8,
          fontSize: 13,
          padding: "10px 16px",
      
                              }}>
                                <p>Opening Balance</p>
                                <p style={{
                                      textAlign: 'right',
                                      fontSize: 14,
                                      fontWeight: 700,
                                      color: '#000000'
                                }}>{
                                  !isNaN(parseFloat(statementBalance)) && statementBalance !== ''
                                    ? parseFloat(statementBalance).toLocaleString('en-NG', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : ''
                                }</p>
      
                              </div>
                              {/* <Form.Label>Opening Balance:</Form.Label>
                              <Form.Control
                                type="text"
                                value={
                                  !isNaN(parseFloat(statementBalance)) && statementBalance !== ''
                                    ? parseFloat(statementBalance).toLocaleString('en-NG', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : ''
                                }
                                onChange={(e) => setStatementBalance(e.target.value)}
                                name="total"
                                disabled
                                style={{ textAlign: 'right' }}
                              /> */}
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                          </Col>
                          {/* <Col md={6}>
                            <Form.Group className="mb-3">
                              <Row>
                                <Col md={5} style={{ textAlign: "right", padding: "5px 0 0 0" }}>
                                  <Form.Label>Opening Balance:</Form.Label>
                                </Col>
                                <Col md={7}>
                                  <Form.Control
                                    type="text"
                                    value={
                                      !isNaN(parseFloat(cashBalance)) && cashBalance !== ''
                                        ? parseFloat(cashBalance).toLocaleString('en-NG', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                        : ''
                                    }
                                    onChange={(e) => setCashBalance(e.target.value)}
                                    name="total"
                                    disabled
                                    style={{ textAlign: 'right' }}
                                  />
                                </Col>
                              </Row>
                            </Form.Group>
                          </Col> */}
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              {/* <Form.Label> */}
                                <a
                                  href={`https://account-api.patna.ng/api/v1/download-bank-statement?province_id=${provinceID}`}
                                  download
                                   style={{ position: 'absolute', top: -50, right: 210 }}
                                >
                                  <b
                                    className={classes.btn1}
                                    style={{ fontSize: "12px",  color: 'blue'}}
                                    variant="success"
                                  >
                                    Download Template
                                  </b>
                                </a>
                              {/* </Form.Label> */}
                              <input
            type="file"
            id="hiddenFileInput"
            accept=".xlsx"
            style={{ display: "none" }}
            onChange={(event) => {
              const file = event.target.files[0];
              if (file) {
                handleImageChange2(event);     // Save the file to state
                                    uploadStatement4(file); 
              }
            }}
          />
          <img
            src={Upload1}
            alt="Upload"
            style={{ cursor: "pointer", height: 60, marginLeft: 60 }}
            onClick={() => document.getElementById("hiddenFileInput").click()}
          />
                              {/* <Form.Control
                                type="file"
                                placeholder="Choose file"
                                accept=".xlsx"
                                // onChange={handleImageChange}
                                // onBlur={uploadStatement3}
                                  onChange={(event) => {
                                  const file = event.target.files[0];
                                  if (file) {
                                    handleImageChange2(event);     // Save the file to state
                                    uploadStatement4(file);        // Immediately trigger API call
                                  }
                                }}
                              /> */}
                            </Form.Group>
                          </Col>
                        </Row>
                          <div className={`row ${classes.awrow1}`}>
                            <div className={classes.mainTable}>
                              <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto',  fontFamily: "'Times New Roman', Times, serif", }}>
            <table className="table display  bg-white m-0 card-table" style={{fontFamily: "'Times New Roman', Times, serif"}}>
              <thead style={{ whiteSpace: "nowrap" }}>
                                   <tr>
                  <th style={{ 
                    position: 'sticky', 
                    top: 0, 
                    background: '#f5f7fb', 
                    zIndex: 2, 
                    width: "12%", 
                    padding: "12px 10px", 
                    textAlign: "center",
                    fontWeight: 700,
                    color: '#000',
                    border: 'none',
                    fontSize: '12px'
                  }}>Post Date</th>
                  <th style={{ 
                    position: 'sticky', 
                    top: 0, 
                    background: '#f5f7fb', 
                    zIndex: 2, 
                    width: "12%", 
                    padding: "12px 10px", 
                    textAlign: "center",
                    fontWeight: 700,
                    color: '#000',
                    border: 'none',
                    fontSize: '12px'
                  }}>Val Date</th>
                  <th style={{ 
                    position: 'sticky', 
                    top: 0, 
                    background: '#f5f7fb', 
                    zIndex: 2, 
                    width: "46%", 
                    padding: "12px 10px", 
                    textAlign: "center",
                    fontWeight: 700,
                    color: '#000',
                    border: 'none',
                    fontSize: '12px'
                  }}>Description</th>
                  <th style={{ 
                    position: 'sticky', 
                    top: 0, 
                    background: '#f5f7fb', 
                    zIndex: 2, 
                    textAlign: "center", 
                    width: "15%", 
                    padding: "12px 10px",
                    fontWeight: 700,
                    color: '#000',
                    border: 'none',
                    fontSize: '12px'
                  }}>Debit</th>
                  <th style={{ 
                    position: 'sticky', 
                    top: 0, 
                    background: '#f5f7fb', 
                    zIndex: 2, 
                    textAlign: "center", 
                    width: "15%", 
                    padding: "12px 10px",
                    fontWeight: 700,
                    color: '#000',
                    border: 'none',
                    fontSize: '12px'
                  }}>Credit</th>
                </tr>
                                  </thead>
      
                                  <tbody>
                                    {balances2.map((item, index) => (
                                      <tr key={index} style={{ padding: "0 5px", margin: "2px 10px", fontSize: 12 }}>
                    <td style={{ padding: "0 5px", }}>{item.post_date}</td>
                    <td style={{ padding: "0 5px", }}>{item.val_date}</td>
                    <td style={{ padding: "0 5px", }}>{item.description}</td>
                    <td style={{ textAlign: "right", padding: "0 5px" }}>
                      {parseFloat(item.debit).toLocaleString('en-US', {
                        minimumIntegerDigits: 1,
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </td>
                    <td style={{ textAlign: "right", padding: "0 5px" }}>
                      {parseFloat(item.credit).toLocaleString('en-US', {
                        minimumIntegerDigits: 1,
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </td>
                  </tr>
                                    ))}
                                    </tbody>
                                </table>
                              </div>
                            <div style={{ marginTop: "15px" }} />
                              <Row>
                                <Col md={4}>
                                  <Form.Group className="mb-3">
                                    <div style={{
                                    background: '#f5f7fb',
          borderRadius: 8,
          fontSize: 13,
          padding: "10px 16px",
      
                              }}>
                                <p>Closing Balance</p>
                                <p style={{
                                      textAlign: 'right',
                                      fontSize: 14,
                                      fontWeight: 700,
                                      color: '#000000'
                                }}>{closingBalance2}</p>
      
                              </div>
                                    {/* <Form.Label>Closing Balance:</Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={closingBalance2}
                                      name="total"
                                      disabled
                                      style={{ textAlign: 'right' }}
                                    /> */}
                                  </Form.Group>
                                </Col>
                                <Col md={2}>
                                </Col>
                                <Col md={6}>
                                  <Row>
                                    <Col md={6}>
                                    <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                                      <div style={{
                                    background: '#f5f7fb',
          borderRadius: 8,
          fontSize: 13,
          padding: "10px 16px",
      
                              }}>
                                <p>Total Credit</p>
                                <p style={{
                                      textAlign: 'right',
                                      fontSize: 14,
                                      fontWeight: 700,
                                      color: '#000000'
                                }}>{totalAmountCredit2}</p>
      
                              </div>
                                      {/* <Form.Label>Total Credit:</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="total"
                                        value={totalAmountCredit2}
                                        disabled
                                        style={{ textAlign: 'right' }}
                                      /> */}
                                    </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                    <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                                      <div style={{
                                    background: '#f5f7fb',
          borderRadius: 8,
          fontSize: 13,
          padding: "10px 16px",
      
                              }}>
                                <p>Total Debit</p>
                                <p style={{
                                      textAlign: 'right',
                                      fontSize: 14,
                                      fontWeight: 700,
                                      color: '#000000'
                                }}>{totalAmountDebit2}</p>
      
                              </div>
                                      {/* <Form.Label>Total Debit:</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="total"
                                        value={totalAmountDebit2}
                                        disabled
                                        style={{ textAlign: 'right' }}
                                      /> */}
                                    </Form.Group>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </div>
          
                          </div>
                        </Form.Group>
                      </Form>
                      <Row>
                        <Col md={8}>
                        </Col>
                        <Col md={4} style={{ textAlign: "right", gap: "15px" }}>
                          <Button onClick={() => setShowRemittanceExcelModal(false)}  style={{
                            backgroundColor: 'white',
                        border: '1px solid #f4efefff',
                        color: '#212121ff',
                        borderRadius: 0,
                      marginRight: 10
                          }}>
                            Go back
                          </Button>
                          <Button
                            className={classes.longbtn}
                            variant='success'
                            onClick={postBalances2}
                            disabled={balanceLoading}
                            style={{ backgroundColor: '#092147',
                        borderRadius: 0,
                        border: 'none' }}>
                            {balanceLoading ? (
                              <>
                                <Spinner size='sm' />
                                <span style={{ marginLeft: '5px' }}>Saving...</span>
                              </>
                            ) : (
                              "Save"
                            )}
                          </Button>
                        </Col>
                      </Row>
                    </Modal.Body>
                    {/* <Modal.Footer className="d-flex justify-content-between w-100"> */}
                      <div className="d-flex" style={{padding: 16}}>
                        <p className="mb-0 me-4">Total Debit Count: {totalDebitCount2}</p>
                        <p className="mb-0">Total Credit Count: {totalCreditCount2}</p>
                      </div>
                      {/* <p className="mb-0" style={{ color: "#c90404", cursor: "pointer" }} onClick={handleShow6}>Skip</p> */}
                    {/* </Modal.Footer> */}
                    {balanceLoading && (
                    <div className={classes.overlay}>
                      <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
                    </div>
                  )}
                  </Modal>

                     <Modal show={showCreateAccountModal} onHide={setShowCreateAccountModal} size="md" centered>
                                <Modal.Header closeButton>
                                  <Modal.Title>Select Reconciliation Account</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <Form>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                      <Form.Label className={classes.formLabelCustom}>Select Account</Form.Label>
                                      <Select
                                        className={classes.formControl}
                                        options={opt2}
                                        placeholder="Select Account"
                                        onChange={handleAccountChange2}
                                        menuPortalTarget={document.body}
                                        styles={{
                                          width: "100%",
                                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                          menu: (provided) => ({
                                            ...provided,
                                            maxHeight: '100px',
                                            overflowY: 'auto',
                      
                                          }),
                                        }}
                                      />
                                      
                  
                                      <div style={{ marginTop: 15 }}/>
                                      <Form.Label>Select Date:</Form.Label>
                                      <Form.Control
                                        type="date"
                                        // autoFocus
                                        value={selectedDate}
                                        onChange={(e) => setSelectedDate(e.target.value)}
                                        max={fixedDate || undefined}
                                      />
                                    </Form.Group>
                                  </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button    style={{
                                    backgroundColor: 'white',
                                    border: '1px solid #212121ff',
                                    color: '#212121ff'
                                  }}>
                                    Go back
                                  </Button>
                                  <Button variant="success" onClick={handleReconcilePage2}>
                                      Next
                                  </Button>
                                </Modal.Footer>
                  
                              </Modal>

       <Modal show={showImportTransactionsModal} onHide={() => setShowImportTransactionsModal(false)} size="lg" keyboard={true} centered dialogClassName={classes.customModalWidth}>
                    {/* <Modal.Header closeButton> */}
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: 16,
                    }}>
                      <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                     
                    }}>
                      <Modal.Title style={{fontSize: 16, fontWeight: 700}}>Cashbook</Modal.Title>
                        <p style={{fontSize: 14}}>Imported cashbook record.</p>
                      </div>
      
      <IoCloseCircleOutline onClick={() => setShowImportTransactionsModal(false)} style={{color: 'blue', fontSize: 30, cursor: 'pointer'}}/>
                    </div>
                    
                   
                    <Modal.Body>
                     
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Row>
                          <Col md={4}>
                            <Form.Group className="mb-3">
                              <div style={{
                                    background: '#f5f7fb',
          borderRadius: 8,
          fontSize: 13,
          padding: "10px 16px",
      
                              }}>
                                <p>Opening Balance</p>
                                <p style={{
                                      textAlign: 'right',
                                      fontSize: 14,
                                      fontWeight: 700,
                                      color: '#000000'
                                }}>{
                                  !isNaN(parseFloat(cashBalance)) && cashBalance !== ''
                                    ? parseFloat(cashBalance).toLocaleString('en-NG', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : ''
                                }</p>
      
                              </div>
                              
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                          </Col>
                          
                          {/* <Col md={6} >
        <Form.Group className="mb-3" >
          
            <a
              href={`https://account-api.patna.ng/api/v1/download-bank-statement?province_id=${provinceID}`}
              download
              style={{ position: 'absolute', top: -50, right: 210 }}
            >
              <b
                className={classes.btn1}
                style={{ fontSize: "12px",  color: 'blue'}}
                variant="success"
              >
                Download Template
              </b>
            </a>
          
      
          <input
            type="file"
            id="hiddenFileInput"
            accept=".xlsx"
            style={{ display: "none" }}
            onChange={(event) => {
              const file = event.target.files[0];
              if (file) {
                handleImageChange(event);
                uploadStatement3(file);
              }
            }}
          />
      
          
          <img
            src={Upload}
            alt="Upload"
            style={{ cursor: "pointer", height: 60, marginLeft: 120 }}
            onClick={() => document.getElementById("hiddenFileInput").click()}
          />
        </Form.Group>
      </Col> */}
      
                        </Row>
                        <div className={`row ${classes.awrow1}`}>
        <div className={classes.mainTable}>
          <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto',  fontFamily: "'Times New Roman', Times, serif", }}>
            <table className="table display  bg-white m-0 card-table" style={{fontFamily: "'Times New Roman', Times, serif"}}>
              <thead style={{ whiteSpace: "nowrap" }}>
                <tr>
                  <th style={{ 
                    position: 'sticky', 
                    top: 0, 
                    background: '#f5f7fb', 
                    zIndex: 2, 
                    width: "12%", 
                    padding: "12px 10px", 
                    textAlign: "center",
                    fontWeight: 700,
                    color: '#000',
                    border: 'none',
                    fontSize: '12px'
                  }}>Post Date</th>
                  <th style={{ 
                    position: 'sticky', 
                    top: 0, 
                    background: '#f5f7fb', 
                    zIndex: 2, 
                    width: "12%", 
                    padding: "12px 10px", 
                    textAlign: "center",
                    fontWeight: 700,
                    color: '#000',
                    border: 'none',
                    fontSize: '12px'
                  }}>Val Date</th>
                  <th style={{ 
                    position: 'sticky', 
                    top: 0, 
                    background: '#f5f7fb', 
                    zIndex: 2, 
                    width: "46%", 
                    padding: "12px 10px", 
                    textAlign: "center",
                    fontWeight: 700,
                    color: '#000',
                    border: 'none',
                    fontSize: '12px'
                  }}>Description</th>
                  <th style={{ 
                    position: 'sticky', 
                    top: 0, 
                    background: '#f5f7fb', 
                    zIndex: 2, 
                    textAlign: "center", 
                    width: "15%", 
                    padding: "12px 10px",
                    fontWeight: 700,
                    color: '#000',
                    border: 'none',
                    fontSize: '12px'
                  }}>Debit</th>
                  <th style={{ 
                    position: 'sticky', 
                    top: 0, 
                    background: '#f5f7fb', 
                    zIndex: 2, 
                    textAlign: "center", 
                    width: "15%", 
                    padding: "12px 10px",
                    fontWeight: 700,
                    color: '#000',
                    border: 'none',
                    fontSize: '12px'
                  }}>Credit</th>
                </tr>
              </thead>
      
              <tbody>
                {currentRows.map((item, index) => (
                  <tr key={index} style={{ padding: "0 5px", margin: "2px 10px", fontSize: 12 }}>
                    <td style={{ padding: "0 5px", textAlign: 'left' }}>{formatDate(item.created_at)}</td>
                    <td style={{ padding: "0 5px",  textAlign: 'left'}}>{item.transaction_date}</td>
                    <td style={{ padding: "0 5px",  textAlign: 'left'}}>{item.details}</td>
                    <td style={{ textAlign: "right", padding: "0 5px" }}>
{ parseFloat(item.debit).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}
</td>

<td style={{ textAlign: "right", padding: "0 5px" }}>
   { parseFloat(item.credit).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}
    
</td>

                  </tr>
                ))}
              </tbody>
            </table>
            
            {/* Pagination Controls */}
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div>
                <button
                  className="btn btn-sm btn-light me-2"
                  onClick={() => setCurrentPage2(prev => Math.max(prev - 1, 1))}
                  disabled={currentPage2 === 1}
                >
                  Previous
                </button>
                <button
                  className="btn btn-sm btn-light"
                  onClick={() => setCurrentPage2(prev => Math.min(prev + 1, totalPages2))}
                  disabled={currentPage2 === totalPages2}
                >
                  Next
                </button>
              </div>
      
              <div>
                <span>Page {currentPage2} of {totalPages2}</span>
              </div>
      
              <div>
                <label className="me-2">Rows per page:</label>
                <select
                  className="form-select form-select-sm"
                  value={rowsPerPage}
                  onChange={(e) => {
                    setRowsPerPage(Number(e.target.value));
                    setCurrentPage2(1);
                  }}
                  style={{ width: "auto", display: "inline-block" }}
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={75}>75</option>
                  <option value={100}>100</option>
                </select>
              </div>
            </div>
          </div>
          
          <div style={{ marginTop: "15px" }} />
          <Row>
             
            <Col md={4}>
              <Form.Group className="mb-3">
                <div style={{
                                    background: '#f5f7fb',
          borderRadius: 8,
          fontSize: 13,
          padding: "10px 16px",
      
                              }}>
                                <p>Closing Balance</p>
                                <p style={{
                                      textAlign: 'right',
                                      fontSize: 14,
                                      fontWeight: 700,
                                      color: '#000000'
                                }}>{closingBalance}</p>
      
                              </div>
               
              </Form.Group>
            </Col>
            <Col md={2}>
            </Col>
            <Col md={6}>
              <Row>
               
                <Col md={6}>
                  <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                     <div style={{
                                    background: '#f5f7fb',
          borderRadius: 8,
          fontSize: 13,
          padding: "10px 16px",
      
                              }}>
                                <p>Total Credit</p>
                                <p style={{
                                      textAlign: 'right',
                                      fontSize: 14,
                                      fontWeight: 700,
                                      color: '#000000'
                                }}>{totalAmountCredit}</p>
      
                              </div>
                    
                  </Form.Group>
                </Col>
                
                <Col md={6}>
                  <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                    <div style={{
                                    background: '#f5f7fb',
          borderRadius: 8,
          fontSize: 13,
          padding: "10px 16px",
      
                              }}>
                                <p>Total Debit</p>
                                <p style={{
                                      textAlign: 'right',
                                      fontSize: 14,
                                      fontWeight: 700,
                                      color: '#000000'
                                }}>{totalAmountDebit}</p>
      
                              </div>
                   
                  </Form.Group>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
                        </Form.Group>
                      {/* </Form> */}
                      <Row>
                        <Col md={8}>
                        </Col>
                        <Col md={4} style={{ textAlign: "right", gap: "15px",  }}>
                          <Button onClick={() => setShowImportTransactionsModal(false)}   style={{
                            backgroundColor: 'white',
                        border: '1px solid #f4efefff',
                        color: '#212121ff',
                        borderRadius: 0,
                      marginRight: 10
                          }}>
                            Go back
                          </Button>
                          <Button
                          style={{
                        backgroundColor: '#092147',
                        borderRadius: 0,
                        border: 'none'
                      }}
                            className={classes.longbtn}
                            variant='primary'
                            // onClick={() => setShowImportTransactionsModal(false)}
                            onClick={postBalances1}
                            >
                              Update
                          </Button>
                        </Col>
                      </Row>
                    </Modal.Body>
                    {/* <Modal.Footer className="d-flex justify-content-between w-100"> */}
                    
                      <div className="d-flex" style={{padding: 16}}>
                        <p className="mb-0 me-4">Total Debit Count: {totalDebitCount}</p>
                        <p className="mb-0">Total Credit Count: {totalCreditCount}</p>
                      </div>
                      {/* <div style={{ display: "flex", justifyContent: "flex-end", padding: 16 }}>
        <p
          className="mb-0"
          style={{ color: "#c90404", cursor: "pointer" }}
          onClick={handleShow6}
        >
          Skip
        </p>
      </div> */}
      {balanceLoading && (
                    <div className={classes.overlay}>
                      <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
                    </div>
                  )}
                    {/* </Modal.Footer> */}
                  </Modal>

 <Modal  size="md" centered>
              {/* <Modal.Header closeButton> */}
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: 16,
              }}>
                <div style={{
                display: 'flex',
                flexDirection: 'column',
               
              }}>
                <Modal.Title style={{fontSize: 16, fontWeight: 700}}>Import Cashbook</Modal.Title>
                <p style={{fontSize: 14}}>Select your account to import your cashbook.</p>
              {/* </Modal.Header> */}
              </div>
              <IoCloseCircleOutline onClick={() => setShowImportTransactionsModal(false)} style={{color: 'blue', fontSize: 30, cursor: 'pointer'}}/>
              </div>
              <Modal.Body>
                <Form>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label className={classes.formLabelCustom}>Select Account</Form.Label>
                    <Select
                      className={classes.formControl}
                      options={optProcess}
                      placeholder="Select Account"
                      onChange={handleAccountChangeProcess}
                      menuPortalTarget={document.body}
                      styles={{
                        width: "100%",
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (provided) => ({
                          ...provided,
                          maxHeight: '300px',
                          overflowY: 'auto',
    
                        }),
                      }}
                    />
                    <Row>
                      <Col md={6}>
                        <div style={{ marginTop: 15 }}/>
                        <Form.Label>Cashbook Date:</Form.Label>
                        <Form.Control
                          type="date"
                          // autoFocus
                          value={fixedDate2}
                          // value={selectedDate}
                          disabled
                          // onChange={(e) => setSelectedDate(e.target.value)}
                          // max={fixedDate2 || undefined}
                        />
                      </Col>
                      <Col md={6}>
                        <div style={{ marginTop: 15 }}/>
                        <Form.Label>Statement Date:</Form.Label>
                        <Form.Control
                          type="date"
                          disabled
                          // autoFocus
                          value={fixedDate}
                          // value={selectedDate}
                          // onChange={(e) => setSelectedDate(e.target.value)}
                          // max={fixedDate || undefined}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </Form>
              </Modal.Body>
    
              {/* <Modal.Footer className="d-flex justify-content-center"> */}
              {/* <Modal.Footer> */}
              <div className="d-flex" style={{padding: 16, display:  'flex', justifyContent: 'flex-end', gap: 10}}>
                <Button onClick={() => setShowImportTransactionsModal(false)}   style={{
                  backgroundColor: 'white',
                  border: '1px solid #f4efefff',
                  color: '#212121ff',
                  borderRadius: 0,
                marginRight: 10
                    }}>
                  Go back
                </Button>
                <Button  style={{ backgroundColor: '#092147',
                  borderRadius: 0,
                  border: 'none' }} variant="success" onClick={pullCashbook}>
                    Continue ⊕
                </Button>
                </div>
              {/* </Modal.Footer> */}
 {createLoading2 && (
              <div className={classes.overlay}>
                <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
              </div>
            )}
            </Modal>

      {/* {showCreateAccountModal && (
  <CreateAccountModalPage 
    onShow={showCreateAccountModal}
    onClose={() => setShowCreateAccountModal(false)}
  />
)} */}
      {/* Automatic Matching Modal */}
<Modal show={showAutomaticMatchingModal} onHide={() => setShowAutomaticMatchingModal(false)} centered>
  {/* <Modal.Header closeButton> */}
    <Modal.Title style={{fontSize: 16, fontWeight: 'bold', padding: 16}}>Automatic Matching Options</Modal.Title>
  {/* </Modal.Header> */}
  <Modal.Body>
    <Form>
      <div className="mb-4">
        <p className="mb-3">Select matching criteria:</p>
        <div className="d-flex flex-column gap-3">
  <div className="form-check">
    <input
      className="form-check-input"
      type="checkbox"
      id="exactMatch"
      checked={matchingOptions.exactMatch}
      onChange={() => handleMatchingOptionChange('exactMatch')}
    />
    <label className="form-check-label" htmlFor="exactMatch">
      Exact Match
    </label>
  </div>
  
  <div className="form-check">
    <input
      className="form-check-input"
      type="checkbox"
      id="manyToManyMatches"
      checked={matchingOptions.manyToManyMatches}
      onChange={() => handleMatchingOptionChange('manyToManyMatches')}
    />
    <label className="form-check-label" htmlFor="manyToManyMatches">
      Many to Many Matches
    </label>
  </div>
  
  <div className="form-check">
    <input
      className="form-check-input"
      type="checkbox"
      id="similarDetailsMatches"
      checked={matchingOptions.similarDetailsMatches}
      onChange={() => handleMatchingOptionChange('similarDetailsMatches')}
    />
    <label className="form-check-label" htmlFor="similarDetailsMatches">
      Similar Details Matches
    </label>
  </div>
  
  <div className="form-check">
    <input
      className="form-check-input"
      type="checkbox"
      id="similarDetailsMatchesReversal"
      checked={matchingOptions.similarDetailsMatchesReversal}
      onChange={() => handleMatchingOptionChange('similarDetailsMatchesReversal')}
    />
    <label className="form-check-label" htmlFor="similarDetailsMatchesReversal">
      Similar Details Matches Reversal
    </label>
  </div>
  
  <div className="form-check">
    <input
      className="form-check-input"
      type="checkbox"
      id="dirtyMatches"
      checked={matchingOptions.dirtyMatches}
      onChange={() => handleMatchingOptionChange('dirtyMatches')}
    />
    <label className="form-check-label" htmlFor="dirtyMatches">
      Dirty Matches
    </label>
  </div>
</div>
      </div>
    </Form>
  </Modal.Body>
 <div style={{
  display: 'flex',
  flexDirection: 'row',
  gap: 10,
  padding: 16
 }}>
    <Button style={{
        borderRadius: 0,
        border: 'none'
      }} variant="secondary" onClick={() => setShowAutomaticMatchingModal(false)}>
      Cancel
    </Button>
    <Button 
      variant="primary" 
      onClick={handleStartMatching}
      style={{
        backgroundColor: '#092147',
        borderRadius: 0,
          border: 'none'
      }}
      disabled={!Object.values(matchingOptions).some(option => option)}
    >
      Start Matching
    </Button>
</div>
</Modal>
<Modal show={showTypeModal} onHide={handleCloseTypeModal} centered style={{ zIndex: 9999 }}>
  <Modal.Header closeButton>
    <Modal.Title>Select Payable Type</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div className="d-flex flex-column gap-2">
      <Button className={classes.sabtn}  onClick={() => handleSelectType("Salary")}>
        Salary Payable
      </Button>
      <Button className={classes.btnpayab}  onClick={() => handleSelectType("Pension")}>
        Pension / PAYE Payable
      </Button>
    </div>
  </Modal.Body>
</Modal>

{/* Step 2: Upload Form */}
<Modal show={showFormModal} onHide={handleCloseFormModal} centered>
  <Modal.Header closeButton>
    <Modal.Title>
      {payableType === "Salary"
        ? "Upload Salary Payable"
        : "Upload Pension / PAYE Payable"}
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        console.log("Submit", payableType);
        handleCloseFormModal();
      }}
    >
      {payableType === "Salary" && (
        <a style={{  }} href={`https://account-api.patna.ng/api/v1/download-payable-excel`} download>
                                    <Button
                                      className={classes.btntemp}
                                      style={{ width: 200, height: "30px", padding: "0", borderRadius: 5, marginBottom: 10}}  >
                                      Download Template
                                    </Button>
                                  </a>
        )}
        {payableType === "Pension" && (
        <a style={{ marginLeft: 10 }} href={`https://account-api.patna.ng/api/v1/download-payable-excel`} download>
                                    <Button
                                      className={classes.btntemp}
                                      style={{ width: 200, height: "30px", padding: "0", borderRadius: 5 , marginBottom: 10}} variant='success' >
                                      Download Template
                                    </Button>
                                  </a>
        )}
        <Modal.Footer />
      <Form.Group className="mb-3">
        
        <Form.Label>Payable Account</Form.Label>
         <Select isLoading={loading} options={debit2} onChange={handlePayables}  placeholder='Select Payable Account' 
                                                        menuPortalTarget={document.body}
                                                        styles={{ width: '80vh',
        
                                                          menuPortal: (base) => ({ ...base, zIndex: 9999, width: '40vh' }),
                                                          menu: (provided) => ({
                                                            ...provided,
                                                            maxHeight: '300px',
                                                            maxWidth: '700px',
                                                            overflowY: 'auto',
                                                            marginLeft: '20px',
                                                          }),
                                                        }}
                                                      />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Expenses Account</Form.Label>
        <Select isLoading={loading} options={debit1} onChange={handledExpenses}  placeholder='Select Expenses Account' 
                                    menuPortalTarget={document.body}
                                    styles={{
        
                                      menuPortal: (base) => ({ ...base, zIndex: 9999, width: '40vh'}),
                                      menu: (provided) => ({
                                        ...provided,
                                        maxHeight: '300px',
                                        maxWidth: '700px',
                                        overflowY: 'auto',
                                      }),
                                    }}
                                  />
      </Form.Group>

      {payableType === "Pension" && (
        <Form.Group className="mb-3">
          <Form.Label>Select PFA/Tax Agents</Form.Label>
          <Select
                                    value={selectedBeneficiary}
                                      onChange={setSelectedBeneficiary}
                                      options={tableData}
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        menu: (provided) => ({
                                          ...provided,
                                          maxHeight: '300px',
                                          maxWidth: '300px',
                                          overflowY: 'auto',
                                        }),
                                      }}
                                    />
        </Form.Group>
      )}

      <Form.Group className="mb-3">
        <Form.Label>Date</Form.Label>
        <Form.Control type="date"  min={minDate}
                max={maxDate}  value={date} onChange={(e) => setDate(e.target.value)} required />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>File</Form.Label>
        <Form.Control
                                              type="file"
                                              placeholder="Choose file"
                                              accept=".xlsx"
                                              onChange={handleImageChangessss}
        
                                            />
      </Form.Group>

      

      <div className="d-flex justify-content-end gap-2">
        <Button variant="secondary" onClick={handleCloseFormModal}>
          Cancel
        </Button>
        <Button style={{ background: "linear-gradient(to bottom, var(--primary-color), var(--light-primary))"}} onClick={payableType === "Salary" ? uploadStatement : uploadStatements}  >
          {createLoading ? (
                                              <>
                                                <Spinner size='sm' />
                                                <span style={{ marginLeft: '5px' }}>Uploading, Please wait...</span>
                                              </>
                                            ) : (
                                              "Upload"
                                            )}
        </Button>
      </div>
    </Form>
  </Modal.Body>
</Modal>

          <Modal show={showCustomer} onHide={handleCloseCustomer} animation={false}>
                                <Modal.Header closeButton>
                                  <Modal.Title>Upload Loan</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <Form style={{ marginTop: 20 }}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    
                                    {/* <div style={{ marginTop: 10 }}>
                                    
                                              <label for="example-text-input" style={{textAlign: "right"}}>Select Account</label>
                                              <div style={{width:'100%'}}>
                                                <Select
                                                    value={banks.find((b) => b.value === selectedBank) || null}
                                                  onChange={(selectedOption) => handleBankChange(selectedOption)}
                                                  options={banks}
                                                  menuPortalTarget={document.body}
                                                  styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    menu: (provided) => ({
                                                      ...provided,
                                                      maxHeight: '400px',
                                                      overflowY: 'auto',
                                                    }),
                                                  }}
                                                />
                                              </div>
                                             
                                    
                                      </div> */}
          
                                     
          
                                      <div style={{ marginTop: 10 }} >
                                      {/* <div className={`${classes.formFlex} ${classes.formFlex2}`}> */}
                                <label for="example-text-input" style={{ textAlign: "right" }}>Loan Type</label>
                                <div style={{ width: '100%' }}>
                                  <Select
                                    // value={selectedLoan}
                                    value={loans.find((l) => l.value === selectedLoan) || null}
                                    onChange={(selectedOption) => handleLoanTypeChange(selectedOption)}
                                    options={loans}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      menu: (provided) => ({
                                        ...provided,
                                        maxHeight: '400px',
                                        overflowY: 'auto',
                                      }),
                                    }}
                                  />
                                </div>
                              {/* </div> */}
                                      </div>
          
                                      <div style={{marginTop: 10, marginLeft: 7}}>
                                    <Form.Label>File  
                                    {/* <span style={{marginLeft: 8}}><a href="https://account-api.patna.ng/api/v1/download-staff-loan" download>
                           <span style={{cursor: "pointer", fontStyle: "italic" }}>Downoload Template</span>
                          </a>
                                    </span> */}
                                    </Form.Label>
                                                <Form.Control
                                                  type="file"
                                                  placeholder="Choose file"
                                                  accept=".xlsx, .xls"
                                                  onChange={handleImageChange}
                                                />
                                  </div>
                                     
                                    </Form.Group>
                                  </Form>
                                </Modal.Body>
          
                                <Modal.Footer>
                                  <Button variant="danger" onClick={handleCloseCustomer}>
                                    Go back
                                  </Button>
                                  <Button variant="success" 
                                  onClick={createLoans}
                                  >
                                    {loading ? (
                                      <>
                                        <Spinner size='sm' />
                                        <span style={{ marginLeft: '5px' }}>Uploading Loan, Please wait...</span>
                                      </>
                                    ) : (
                                      "Upload Loan"
                                    )}
                                  </Button>
                                </Modal.Footer>
                              </Modal>

<Modal size='lg' show={showLoanModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Loan Disbursement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form>
          <p style={{
            fontWeight: 'bold',
            marginBottom: 10,
            fontSize: 16,
            color: '#000'
          }}>Upload Loan Disbursement</p>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            // justifyContent: 'flex-end',
            alignItems: 'center',
            gap: 10,
            marginBottom: 10
          }}>
          <div>
                    <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="download-tooltip">
                  Click here to download template
                </Tooltip>
              }
            >
              <a href="https://account-api.patna.ng/api/v1/download-staff-loan-disbursement" download>
              <div style={{
                width: 200,
                height: 40,
                borderRadius: 8,
                backgroundColor: '#fff',
                border: '1px solid rgb(187, 183, 183)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <p style={{
              marginTop: -3,
                
                  color: '#000'
                }}>Download Template</p>
              </div>
                 {/* <i className="fa fa-download" style={{ color: "#3770ab",  borderColor: "#3770ab", borderRadius: 5, fontSize: 23, cursor: "pointer", marginTop: 7 }}></i> */}
              </a>
            </OverlayTrigger>
                    </div>
                      <div>
                      <OverlayTrigger
                    placement="top"
                    className={classes.btndf1}
                    overlay={<Tooltip id="button-tooltip"  className={classes.btndf1}>Click here to upload loan</Tooltip>}
                  >
                    <Button variant='success' className={classes.btn2}  onClick={handleShowCustomer} >
                      Upload Loan
                    </Button>
                  </OverlayTrigger>
                      </div>

                      {/* <Button variant="success" onClick={handleCreate} className={classes.btn1}>  Create New Loan  </Button> */}
                      </div>
                <Modal.Footer />
      <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="transactionDate">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Transaction Date
              </Form.Label>
              <Form.Control
                type="date"
                name="date"
                value={selectedDatess}
                onChange={handleDateChangess}
                min={minDate}
                max={maxDate}
                required
                style={{ flex: 1 }}
              />
            </div>
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="member">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Member
              </Form.Label>
              <div style={{ flex: 1 }}>
                <Select
                  onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                  options={selectOptions}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: '300px',
                      overflowY: 'auto',
                    }),
                    control: (provided) => ({
                      ...provided,
                      width: '100%',
                    }),
                  }}
                />
              </div>
            </div>
          </Form.Group>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="loanType">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Loan Type
              </Form.Label>
              <div style={{ flex: 1 }}>
                <Select
                  onChange={(selectedOption) => handleLoanTypeChange(selectedOption)}
                  options={loans}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: '200px',
                      overflowY: 'auto',
                    }),
                    control: (provided) => ({
                      ...provided,
                      width: '100%',
                    }),
                  }}
                />
              </div>
            </div>
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="principalAmount">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Principal Amount
              </Form.Label>
              <CurrencyInput
                name="principal amount"
                decimalsLimit={2}
                className="form-control"
                value={principalAmount}
                onValueChange={handleValueChange}
                style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
              />
            </div>
          </Form.Group>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="loanInterest">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Loan Interest
              </Form.Label>
              <CurrencyInput
                name="loan interest"
                decimalsLimit={2}
                className="form-control"
                value={loanInterest}
                disabled
                onValueChange={handleValueChange1}
                style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
              />
            </div>
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="interest">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Interest
              </Form.Label>
              <CurrencyInput
                name="interest"
                decimalsLimit={2}
                className="form-control"
                value={interest}
                disabled
                onValueChange={handleValueChange2}
                style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
              />
            </div>
          </Form.Group>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="totalRepayment">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Total Repayment
              </Form.Label>
              <CurrencyInput
                name="total repayment"
                decimalsLimit={2}
                className="form-control"
                value={totalRepayment}
                disabled
                onValueChange={handleValueChange3}
                style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
              />
            </div>
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="duration">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Duration (Months)
              </Form.Label>
              <Form.Control
                type="text"
                name="duration"
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
                required
                style={{ flex: 1 }}
              />
            </div>
          </Form.Group>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="monthlyDeduction">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Monthly Deduction
              </Form.Label>
              <CurrencyInput
                name="monthly deduction"
                decimalsLimit={2}
                className="form-control"
                value={monthlyDeduction}
                disabled
                onValueChange={handleValueChange4}
                style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
              />
            </div>
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="selectBank">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Select Bank
              </Form.Label>
              <div style={{ flex: 1 }}>
                <Select
                  value={selectedBanks}
                  onChange={(selectedOption) => handleBankChange(selectedOption)}
                  options={banks}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: '200px',
                      overflowY: 'auto',
                    }),
                    control: (provided) => ({
                      ...provided,
                      width: '100%',
                    }),
                  }}
                />
              </div>
            </div>
          </Form.Group>
        </div>
      </div>

      {/* Commented-out Cheque No. field */}
      {/* <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="chequeNo">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Cheque No.
              </Form.Label>
              <Form.Control
                type="text"
                name="cheque no"
                value={cheque}
                onChange={(e) => setCheque(e.target.value)}
                required
                style={{ flex: 1 }}
              />
            </div>
          </Form.Group>
        </div>
      </div> */}
    </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
         <Button style={{ borderRadius: 0 }} variant='success' onClick={createLoan} >
                       {createLoading ? (
                         <>
                           <Spinner size='sm' />
                           <span style={{ marginLeft: '5px' }}>Creating, Please wait...</span>
                         </>
                       ) : (
                         "Create New Loan"
                       )}
                     </Button>
        </Modal.Footer>
      </Modal>
<Modal size="lg" show={showRemittanceModal}  onHide={() => setShowRemittanceModal(false)} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title  style={{fontSize: 16, fontWeight: 'bold'}}>Add Receipt</Modal.Title>
        </Modal.Header>
        <Modal.Body>
       <Form>
  {/* Row 1 */}
  <Row>
      <Col md={4}>
      <Form.Group className="mb-3">
        <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
          Transaction Date
        </Form.Label>
        <Form.Control
          type="date"
          value={selectedDate}
          onChange={handleDateChange}
          style={{ fontSize: 14 }}
        />
      </Form.Group>
    </Col>

    <Col md={4}>
      <Form.Group className="mb-3">
        <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
          Customer
        </Form.Label>
        <Select
          onChange={handleCustomerChange}
          options={cus}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            control: (base) => ({
              ...base,
              fontSize: 14,
              minHeight: 38,
            }),
            singleValue: (base) => ({ ...base, fontSize: 14 }),
          }}
        />
      </Form.Group>
    </Col>

     <Col md={4}>
      <Form.Group className="mb-3">
        <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
          Outstanding
        </Form.Label>
        <CurrencyInput
          name="amount"
          decimalsLimit={2}
          className="form-control"
          value={outstanding}
          disabled
          style={{
            textAlign: "right",
            border: "1px solid #e4e4e4",
            fontSize: 14,
          }}
        />
      </Form.Group>
    </Col>

    
  </Row>

  {/* Row 2 */}
  <Row>
 <Col md={4}>
      <Form.Group className="mb-3">
        <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
          Description
        </Form.Label>
        <Form.Control
          as="textarea"
          rows={1}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          style={{ fontSize: 14 }}
        />
      </Form.Group>
    </Col>

    <Col md={4}>
      <Form.Group className="mb-3">
        <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
          Payment Mode
        </Form.Label>
        <Form.Select
          value={selectedPaymentMode}
          onChange={handlePaymentModeChange}
          style={{ fontSize: 14 }}
        >
          <option value="">Select Mode</option>
          {paymentMethod.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </Col>

<Col md={4}>
      <Form.Group className="mb-3">
        <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
          Bank
        </Form.Label>
        <Select
          onChange={handlePaymentChange}
          options={
            selectedPaymentMode === "1" || selectedPaymentMode === "3"
              ? debit3
              : selectedPaymentMode === "2" || selectedPaymentMode === "4"
              ? debit4
              : debit3
          }
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            control: (base) => ({
              ...base,
              fontSize: 14,
              minHeight: 38,
            }),
            singleValue: (base) => ({ ...base, fontSize: 14 }),
          }}
        />
      </Form.Group>
    </Col>
    
  </Row>

  {/* Row 3 */}
  <Row>
  <Col md={4}>
      <Form.Group className="mb-3">
        <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
          Amount
        </Form.Label>
        <CurrencyInput
          name="amount"
          decimalsLimit={2}
          className="form-control"
          value={incomeAmount}
          onValueChange={handleValueChanges}
          style={{
            textAlign: "right",
            border: "1px solid #e4e4e4",
            fontSize: 14,
          }}
        />
      </Form.Group>
    </Col>  

    <Col md={4}>
      <Form.Group className="mb-3">
        <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
          Cheque / Teller No
        </Form.Label>
        <Form.Control
          type="text"
          value={teller}
          onChange={(e) => setTeller(e.target.value)}
          style={{ fontSize: 14 }}
        />
      </Form.Group>
    </Col>


  </Row>
</Form>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" className={classes.btn1} onClick={setShowRemittanceModal}> Cancel</Button>
                        <Button className={classes.btnss} variant='primary' 
               onClick={createRemitance} >
                  Make Payment
                    
                </Button>

        </Modal.Footer>
        {create && (
              <div className={classes.overlay}>
                <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
              </div>
            )}
      </Modal>
      <Modal size='lg'  animation={false}>
  <Modal.Header closeButton>
    <Modal.Title style={{fontSize: 16, fontWeight: 'bold'}}>Remittance - Excel Upload</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      {/* Row 1 */}
      <Row className="g-3">
          <Col md={4} sm={12}>
          <Form.Group controlId="transactionDate" className="mb-3">
            <Form.Label className={classes.formLabelCustom}>Transaction Date</Form.Label>
            <Form.Control
              type="date"
              onChange={handleDateChange}
              value={selectedDate}
              // min={minDate}
              // max={maxDate}
            />
          </Form.Group>
        </Col>

        <Col md={4} sm={12}>
          <Form.Group controlId="customer" className="mb-3">
            <Form.Label className={classes.formLabelCustom}>Customer</Form.Label>
            <Select
              onChange={handleCustomerChange}
              options={cus}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </Form.Group>
        </Col>

      

        {/* <Col md={4} sm={12}>
          <Form.Group controlId="paymentMode" className="mb-3">
            <Form.Label className={classes.formLabelCustom}>Payment Mode</Form.Label>
            <Form.Select
              value={selectedPaymentMode}
              onChange={handlePaymentModeChange}
              style={{ fontSize: 14 }}
            >
              <option value="">Select Mode</option>
              {paymentMethod.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col> */}
        <Col md={4} sm={12}>
          <Form.Group controlId="bank" className="mb-3">
            <Form.Label className={classes.formLabelCustom}>Bank</Form.Label>
            <Select
              onChange={handlePaymentChange}
              options={
               debit3
              }
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </Form.Group>
        </Col>
      </Row>

      {/* Row 2 */}
      <Row className="g-3">
        

        <Col md={4} sm={12}>
          <Form.Group controlId="tellerNo" className="mb-3">
            <Form.Label className={classes.formLabelCustom}>Cheque/Teller No</Form.Label>
            <Form.Control
              type="text"
              value={teller}
              onChange={(e) => setTeller(e.target.value)}
            />
          </Form.Group>
        </Col>

        <Col md={4} sm={12}>
          <Form.Group controlId="uploadExcel" className="mb-3">
            <Form.Label className={classes.formLabelCustom}>Upload Excel File</Form.Label>
            <Form.Control
              type="file"
              accept=".xls,.xlsx"
              onChange={(e) => setExcelFile(e.target.files[0])}
            />
          </Form.Group>
        </Col>
      </Row>

      <Modal.Footer />
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="light" className={classes.btn1} onClick={() => setShowRemittanceExcelModal(false)}>Cancel</Button>
    <Button className={classes.btnss} variant="primary" onClick={uploadRemittance}>
      Upload
    </Button>
  </Modal.Footer>
   {createLoading && (
              <div className={classes.overlay}>
                <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
              </div>
            )}
   
</Modal>

      {/* User section */}
      <div className={`${classes.user} ${classes.desktopOnly}`}>
        {/* <img src={usrnoti} className={classes.bellnoti} alt="Notification" /> */}
        <div className={classes.userProfile} ref={userDropdownRef}>
          <div
            className={classes.userAvatar}
            onClick={() => setUserDropdownOpen(!userDropdownOpen)}
          >
            <p className={classes.usrnm}>
              {initials}
            </p>
          </div>

          {/* User dropdown menu */}
          {userDropdownOpen && (
            <div className={classes.userDropdown}>
              <div className={classes.userInfo}>
                <p className={classes.userName}>{user || 'User'}</p>
                <p className={classes.userEmail}>{userEmail || 'user@example.com'}</p>
              </div>
              <div className={classes.dropdownDivider}></div>
              <button
                type="button"
                className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
                onClick={() => {
                  setShowChangePassword(true);
                  setUserDropdownOpen(false);
                }}
              >
                <img src={stngs} alt="Settings" className={classes.dropdownIcon} />
                Change Password
              </button>

              <button onClick={() => navigate("/welcome")}
              className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
              >
              <img src={stngs} alt="Settings" className={classes.dropdownIcon} />
                Switch Account
              </button>

              <button
                className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
                onClick={() => {
                  handleLogout();
                  setUserDropdownOpen(false);
                  // Redirect to signin page after logout
                  // window.location.href = "/signin";
                }}
              >
                <img src={stngs} alt="Logout" className={classes.dropdownIcon} />
                Logout
              </button>
            </div>
          )}
       
        </div>
      </div>
      <div className={classes.mobileOnly}>
    <button
      className={classes.hamburgerBtn}
      onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
    >
      {isMobileMenuOpen ? <FaRegTimesCircle /> : <CiMenuFries />}
    </button>
  </div>
       {isMobileMenuOpen && (
        <div className={classes.mobileMenu}>
          <div className={classes.mobileMenuContent}>
            {/* All Navigation Links */}
            <div className={classes.mobileNav}>
             {filteredNavItems.map((item) => {
  const isActive = location.pathname.startsWith(item.path);
  const hasDropdown = dropdownMenus[item.label];

  // filter submenu permissions same as desktop
  const filteredDropdownItems = hasDropdown
    ? dropdownMenus[item.label].filter((sub) => {
        if (item.label === "Accounting") {
          return permissions.includes(sub.permission);
        } else {
          return permissions.includes(sub.permission);
        }
      })
    : [];

  return hasDropdown && filteredDropdownItems.length > 0 ? (
    <div key={item.label} className={classes.mobileNavGroup}>
      {/* parent clickable */}
      <div
        className={`${classes.mobileNavItem} ${
          isActive ? classes.activeDropdown : ""
        }`}
        onClick={() =>
          setOpenDropdown(openDropdown === item.label ? null : item.label)
        }
      >
        {item.label}
      </div>

      {/* submenu collapsible */}
      {openDropdown === item.label && (
        <div className={classes.mobileSubmenu}>
          {filteredDropdownItems.map((sub, index) =>
            sub.isUploadPayableModal ? (
              <div
                key={index}
                style={{ cursor: "pointer" }}
                className={classes.mobileSubmenuItem}
                onClick={() => {
                  handleOpenUploadType();
                  setOpenDropdown(null);
                  setMobileMenuOpen(false);
                }}
              >
                {sub.label}
              </div>
            ) : sub.isModal ? (
              <div
                key={index}
                className={classes.mobileSubmenuItem}
                onClick={() => {
                  setShowLoanModal(true);
                  setOpenDropdown(null);
                  setMobileMenuOpen(false);
                }}
              >
                {sub.label}
              </div>
            ) : (
              <NavLink
                key={index}
                to={sub.path}
                onClick={() => {
                  setOpenDropdown(null);
                  setMobileMenuOpen(false);
                }}
                className={({ isActive }) =>
                  `${classes.mobileSubmenuItem} ${
                    isActive ? classes.activeDropdown : ""
                  }`
                }
              >
                {sub.label}
              </NavLink>
            )
          )}
        </div>
      )}
    </div>
  ) : (
    <NavLink
      key={item.label}
      to={item.path}
      onClick={() => setMobileMenuOpen(false)}
      className={({ isActive }) =>
        `${classes.mobileNavItem} ${isActive ? classes.activeDropdown : ""}`
      }
    >
      {item.label}
    </NavLink>
  );
})}

            </div>

            {/* Profile Section inside mobile menu */}
            <div className={classes.mobileProfile}>
              <p className={classes.userName}>{user || "User"}</p>
              <p className={classes.userEmail}>{userEmail || "user@example.com"}</p>

              <button
                className={classes.dropdownItemm}
                onClick={() => {
                  setShowChangePassword(true);
                  setMobileMenuOpen(false);
                }}
              >
                Change Password
              </button>

              <button
                className={classes.dropdownItemm}
                onClick={() => {
                  handleLogout();
                  setMobileMenuOpen(false);
                }}
              >
                Logout
              </button>
            </div>
          </div>
           
        </div>
      )}
    
    </div>
  );
}
